import { useEffect, useMemo, useRef, useState } from "react";
import { useAppThemeContext, useAuthContext } from "../../shered/contexts";
import { LayoutBaseDePagina } from "../../shered/layouts";
import { FerramentasDeDetalhe, SelectComponent } from "../../shered/components";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { VForm, useVForm } from "../../shered/forms";
import {
    Autocomplete, CircularProgress,
    Box, Button, Icon,
    FormControl,
    InputLabel,
    MenuItem,
    Select, Tab, Tabs,
    Paper, Typography, useTheme,
    TextField,
    Card,
    CardActionArea,
    CardMedia,
    CardContent,
    Tooltip
} from "@mui/material";
import Grid from '@mui/material/Grid2';
import clsx from 'clsx';
import { ptBR } from '@mui/x-data-grid/locales';
import { DataGrid, GridActionsCellItem, GridCellParams, GridColDef, GridValueGetterParams } from "@mui/x-data-grid";
import { moedaRealLocaleValue } from "../../shered/components/input-valor-moeda/Current-Mask";
import { DialogMensagem, IDadosModal } from "../../shered/components/modal/DialogMensagem";
import { DialogEvent, IDadosModalEvento } from "../../shered/components/modal/DialogEvent";
import CookieService from "../../shered/services/autenticacao/CookieService";
import { IListagemLigas, LigaService } from "../../shered/services/api/liga/LigaService";
import { IDetalheJogadorFreeAgency, IListagemJogador, JogadorService } from "../../shered/services/api/jogador/JogadorService";
import { AnosTemporadas, ILstDrop, lstPosicaoAmericano, lstReferenciasPosicao, TDropOptions, UtilidadeService } from "../../shered/services/api/utilidades/UtilidadesService";
import { Loading } from "../../shered/components/loading/Loading";
import { FreeagencyService, IDadosContratacaoFreeAgency, IListaDadosLanceFreeAgency, IListagemHistoricoLance, IListagemSalarios, IListagemTimes } from "../../shered/services/api/freeAgency/FreeAgencyService";
import { VTextMaskCustom } from "../../shered/forms/VTextMaskCustom";
import dayjs from 'dayjs'
import { AddTask } from "@mui/icons-material";
import { render } from "react-dom";
import moment from "moment-timezone";
import { FranquiaService } from "../../shered/services/api/franquia/FranquiaService";

interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
}
function TabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;

    return (
        <> {value === index ? 
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {
                // value === index && (
                <Box sx={{ p: UtilidadeService.isMobile() ? 1 : 3 }}>
                    <Grid container>{children}</Grid>
                </Box>
                //)
            }
        </div>
         : ""}
        </>
    );
}

function a11yProps(index: number) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

// export const lstPosicoes = [
//     {
//         codigo: 0,
//         label: "Selecione..."
//     }, {
//         codigo: 1,
//         label: "PG"
//     }, {
//         codigo: 2,
//         label: "SG",
//     }, {
//         codigo: 3,
//         label: "SF",
//     }, {
//         codigo: 4,
//         label: "PF",
//     }, {
//         codigo: 5,
//         label: "C",
//     },];

const carregaPosicao = (posicao_1: string, posicao_2: string | null, posicao_3: string | null) => {
    if (posicao_1 === null) {
        return posicao_1;
    }

    let posicoes = `${UtilidadeService.verificaTipoPosicao(posicao_1)} ${posicao_2 !== null ? " | " : ""} ${posicao_2 !== null ? UtilidadeService.verificaTipoPosicao(posicao_2) : ""} ${posicao_3 !== null ? " | " : ""} ${posicao_3 !== null ? UtilidadeService.verificaTipoPosicao(posicao_3) : ""}`;
    let qtd = posicoes.split("|").length;
    let arrImagens = posicoes.split("|");

    let imgs = qtd === 1 ? <img src={`../../${arrImagens[0]}`} alt={"img1"} width={UtilidadeService.isMobile() ? 18 : 25} height={UtilidadeService.isMobile() ? 18 : 25} style={{ borderRadius: "50%" }} />
        : qtd === 2 ?
            <>  <img src={`../../${arrImagens[0]}`} alt={"img1"} width={UtilidadeService.isMobile() ? 18 : 25} height={UtilidadeService.isMobile() ? 18 : 25} style={{ borderRadius: "50%" }} />
                <img src={`../../${arrImagens[1].replaceAll(" ", "")}`} alt={"img2"} width={UtilidadeService.isMobile() ? 18 : 25} height={UtilidadeService.isMobile() ? 18 : 25} style={{ borderRadius: "50%", marginLeft: 4 }} />
            </>
            : <> <img src={`../../${arrImagens[0]}`} alt={"img1"} width={UtilidadeService.isMobile() ? 18 : 25} height={UtilidadeService.isMobile() ? 18 : 25} style={{ borderRadius: "50%" }} />
                <img src={`../../${arrImagens[1].replaceAll(" ", "")}`} alt={"img2"} width={UtilidadeService.isMobile() ? 18 : 25} height={UtilidadeService.isMobile() ? 18 : 25} style={{ borderRadius: "50%", marginLeft: 4 }} />
                <img src={`../../${arrImagens[2].replaceAll(" ", "")}`} alt={"img3"} width={UtilidadeService.isMobile() ? 18 : 25} height={UtilidadeService.isMobile() ? 18 : 25} style={{ borderRadius: "50%", marginLeft: 4 }} />
            </>

    return imgs
}

export const DetalhesDadosDeFreeAgency: React.FC = () => {
    const theme = useTheme();
    const navigate = useNavigate();
    const { logout } = useAuthContext();
    const user = CookieService.get("access_user");
    const { themeName } = useAppThemeContext();
    const { formRef, save, saveAndClose, isSaveAndClose } = useVForm();
    const buttonRef = useRef(null);
    let codLocal = localStorage.getItem("@codigoLiga");
    const { id } = useParams<"id">();
    const [codigoLiga, setCodigoLiga] = useState(codLocal !== null ? UtilidadeService.decrypt(codLocal) : "0");
    const [codigoFranquia, setCodigoFranquia] = useState(0);
    const [showImagemFranquia, setShowImagemFranquia] = useState<any>("../../../../semimagemescudo.png");
    const [showModalMensagem, setShowModalMensagem] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [edicao, setEdicao] = useState(false);
    const [removeLoading, setRemoveLoading] = useState(false);
    const [redirecionar, setRedirecionar] = useState("");
    const [lstJogadores, setLstJogadores] = useState<TDropOptions[]>([]);
    const [jogadorSelecionado, setJogadorSelecionado] = useState<number>(0);
    const [valorSalarioJogador, setValorSalarioJogador] = useState<string>("");
    const [selectedIdComplete, setSelectedIdComplete] = useState<number | undefined>(0);
    const [selectedIdCompleteFiltro, setSelectedIdCompleteFiltro] = useState<number | undefined>(0);
    const [opcoesAutoCompleteJogador, setOpcoesAutoCompleteJogador] = useState<TDropOptions[]>([]);
    const [opcoesAutoCompleteJogadorFiltro, setOpcoesAutoCompleteJogadorFiltro] = useState<TDropOptions[]>([]);
    const [dadosLiga, setDadosLiga] = useState<IListagemLigas>();
    const [anoSelecionado, setAnoSelecionado] = useState<number>(0);
    const [value, setValue] = useState(0);
    const [aberturaFreeAgency, setAberturaFreeAgency] = useState(false);
    const [aberturaLeilao, setAberturaLeilao] = useState(false);
    const [showGridFreeAgency, setShowGridFreeAgency] = useState(false);
    const [showGridFreeAgencyRestrito, setShowGridFreeAgencyRestrito] = useState(false);

    const [posicao, setPosicao] = useState<number>(0);
    const [searchParams, SetSearchParams] = useSearchParams();
    const [rows, setRows] = useState<IListagemJogador[]>([]);
    const [rowsTimes, setRowsTimes] = useState<IListagemTimes[]>([]);
    const [rowsSalarios, setRowsSalarios] = useState<IListagemSalarios[]>([]);
    const [codigoFreeAgency, setCodigoFreeAgency] = useState<number>(0);
    const [listaLanceFreeAgency, setListaLanceFreeAgency] = useState<IListaDadosLanceFreeAgency[]>([]);
    const [listaLanceFreeAgencyRestrito, setListaLanceFreeAgencyRestrito] = useState<IListaDadosLanceFreeAgency[]>([]);
    const [showBotaoCancelar, setShowBotaoCancelar] = useState(false);
    const [limparFiltros, setLimparFiltros] = useState(false);
    const [posicaoFiltro, setPosicaoFiltro] = useState(0);
    const [codigofranquiaDireitoFiltro, setCodigofranquiaDireitoFiltro] = useState(0);
    const [codigofranquiaLanceFiltro, setCodigofranquiaLanceFiltro] = useState(0);
    const [lstFranquias, setLstFranquias] = useState<ILstDrop[]>([]);
    const [historicoRows, setHistoricoRows] = useState<IListagemHistoricoLance[]>([]);
    const [dataFimLance, setDataFimLance] = useState<any>();
    const [alterouData, setAlterouData] = useState<any>();
    const [tempoLance, setTempoLance] = useState<string>("");
    const [lanceDia, setLanceDia] = useState<number>(0);
    const [lanceHora, setLanceHora] = useState<number>(0);
    const [lanceMinuto, setLanceMinuto] = useState<number>(0);
    const [lanceSegundo, setLanceSegundo] = useState<number>(0);
    const [codigoLance, setCodigoLance] = useState<number>(0);
    const [novoLance, setNovoLance] = useState(false);
    const [desativar, setDesativar] = useState(false);
    const [lstPosicoes, setLstPosicoes] = useState<ILstDrop[]>([]);
    const [dadosModalMensagem, setDadosModalMensagem] = useState<IDadosModal>({
        acao: false,
        label: "",
        tipo: "error",
        mensagem: "Sessão Expirada!",
        display: "none",
        titulo: "Atenção"
    });

    const [showModalEvent, setShowModalEvent] = useState(false);
    const [dadosModalEvent, setDadosModalEvent] = useState<IDadosModalEvento>({
        acao: false,
        label: "",
        tipo: "info",
        mensagem: "Deseja ronovar com o jogador ",
        display: "none",
        titulo: "Atenção"
    });

    const options: Intl.NumberFormatOptions = { style: 'currency', currency: 'BRL', minimumFractionDigits: 0, maximumFractionDigits: 0 }
    const formatNumber = new Intl.NumberFormat('pt-BR', options);

    const autoCompleteSelectedOption = useMemo(() => {
        if (!selectedIdComplete) return null;

        const selectedOption = opcoesAutoCompleteJogador.find(opcao => opcao.codigo === selectedIdComplete);
        if (!selectedOption) return null;

        return selectedOption;
    }, [selectedIdComplete, opcoesAutoCompleteJogador]);


    const autoCompleteSelectedOptionFiltro = useMemo(() => {
        if (!selectedIdCompleteFiltro) return null;

        const selectedOption = opcoesAutoCompleteJogadorFiltro.find(opcao => opcao.codigo === selectedIdCompleteFiltro);
        if (!selectedOption) return null;

        return selectedOption;
    }, [selectedIdCompleteFiltro, opcoesAutoCompleteJogadorFiltro]);

    const [errors, setErrors] = useState({
        error: false,
        nomeFranquiaRef: "",
        showImagemFranquia: ""

    });


    useEffect(() => {
        //let codigoDecrpt = UtilidadeService.decrypt(codigoLiga !== null ? codigoLiga : "0");     
        let codigoLanceUrl = 0;
        if (id !== null && id !== undefined && id !== "" && id !== "0") {
            const resultCrypt = UtilidadeService.decrypt(id);
            if (resultCrypt === "0") {
                setValue(1);
            }
            codigoLanceUrl = Number(resultCrypt);
            setCodigoLance(resultCrypt !== undefined ? Number(resultCrypt) : 0);
            setNovoLance(true);
        }

        if (codigoLiga === "" || codigoLiga === null || codigoLiga === "0") {
            setIsLoading(false);
            setRemoveLoading(true);
            setShowModalMensagem(true);
            setDadosModalMensagem({
                acao: true,
                label: "",
                tipo: "warning",
                mensagem: "Favor selecionar uma liga!",
                display: "none",
                titulo: "Atenção"
            });
            setRedirecionar(`/usuario/liga/${codLocal}`);
            return;
        }
        setIsLoading(true);
        setRemoveLoading(false);
        const fetchData = async () => {
            setLimparFiltros(false);
            FranquiaService.getByIdLiga(Number(codigoLiga)).then(result => {
                let lstFranquia = result.dado.map((f, i) => ({ codigo: f.codigo, label: f.nome === null ? `Franquia ${i + 1} ` : f.nome }));
                setLstFranquias(lstFranquia);
            }).catch((errors) => {
                setRemoveLoading(true);
                setIsLoading(false);
                setShowModalMensagem(true);
                if (errors.response !== undefined) {
                    if (errors.response.data.statusHTTP === 401) {
                        setDadosModalMensagem({
                            acao: true,
                            label: "",
                            tipo: "error",
                            mensagem: "Sessão Expirada! 2",
                            display: "none",
                            titulo: "Atenção"
                        });
                        logout();
                        setRedirecionar("0");
                        return;
                    }
                    setDadosModalMensagem({
                        acao: true,
                        label: "",
                        tipo: "error",
                        mensagem: errors.response.data.mensagem,
                        display: "none",
                        titulo: "Atenção"
                    });
                }
                else {
                    setDadosModalMensagem({
                        acao: true,
                        label: "",
                        tipo: "error",
                        mensagem: "Não foi possível carregar os dados da franquia! Favor entrar em contato com a TI",
                        display: "none",
                        titulo: "Atenção"
                    });
                }
            });
            await LigaService.getDadosLigaPeloCodigo(Number(codigoLiga))
                .then((result) => {
                    const liga = result.dado;
                    setDadosLiga(liga);
                    setAberturaFreeAgency(liga.abertura_Free_Agency);
                    setAberturaLeilao(liga.abertura_Leilao);
                    //setShowGridFreeAgency(liga.abertura_Leilao);
                    setCodigoFreeAgency(liga.codigo_Free_Agency);
                    setCodigoFranquia(liga.codigo_Franquia);

                    const lst: TDropOptions[] = liga.codigo_Tipo_Posicao_Confronto === 2
                        ? lstPosicaoAmericano.map((f) => ({ codigo: f.codigo, label: f.label, descricao: f.label }))
                        : lstReferenciasPosicao.map((f) => ({ codigo: f.codigo, label: f.label, descricao: f.label }));
                    setLstPosicoes(lst)

                    CarregarDadosFreeAgency(liga, codigoLanceUrl);

                })
                .catch((errors) => {
                    setShowModalMensagem(true);
                    setRemoveLoading(true);
                    if (errors.response !== undefined) {
                        if (errors.response.status === 401) {
                            setDadosModalMensagem({
                                acao: true,
                                label: "",
                                tipo: "info",
                                mensagem: "Sessão expirada!",
                                display: "none",
                                titulo: "Atenção"
                            });
                            logout();
                            setRedirecionar("0");
                            return;
                        }
                        setDadosModalMensagem({
                            acao: true,
                            label: "",
                            tipo: "error",
                            mensagem: errors.response.data.mensagem,
                            display: "none",
                            titulo: "Atenção"
                        });
                        setRedirecionar(`/usuario/liga/${codLocal}`);
                        return;
                    }
                    setDadosModalMensagem({
                        acao: true,
                        label: "",
                        tipo: "error",
                        mensagem: "Não foi possível carregar os dados da FA, favor tentar novamente mais tarde. Caso o problema continue, entrar em contato com a TI.",
                        display: "none",
                        titulo: "Atenção"
                    });
                    return;
                });

            await CarregarListaJogadores(true);
        }

        fetchData();
    }, [codigoLiga, limparFiltros]);

    const CarregarDadosFreeAgency = async (liga: IListagemLigas, codigoLanceUrl: number) => {

        setRemoveLoading(false);
        setIsLoading(true);
        await FreeagencyService.getAllPorCodigo(liga.codigo_Free_Agency)
            .then((result) => {
                const dadosFreeAgency = result.data.dado;
                setRowsTimes(dadosFreeAgency.franquia);
                setRowsSalarios(dadosFreeAgency.configuracao_Salario);

                if (dadosFreeAgency.lance_Free_Agency.length > 0) {
                    let dadoLance = dadosFreeAgency.lance_Free_Agency.filter(f => f.codigo === codigoLanceUrl);
                    setListaLanceFreeAgency(dadoLance);
                    let obj = dadosFreeAgency.lance_Free_Agency.sort((a, b) => Number(new Date(b.data_Fim_Lance)) - Number(new Date(a.data_Fim_Lance)));
                    setDataFimLance(obj[dadosFreeAgency.lance_Free_Agency.length - 1].data_Fim_Lance);
                    if (codigoLanceUrl > 0) {
                        handleAcaoLeilao(dadoLance[0], liga.codigo_Franquia, liga.tipo_Free_Agency, liga.codigo_Tipo_Posicao_Confronto, Number(liga.porcentagem_Contrato_Ajustavel));
                    }
                }
                else {
                    setListaLanceFreeAgency([]);
                }
            })
            .catch((errors) => {
                setShowModalMensagem(true);
                setRemoveLoading(true);
                if (errors.response !== undefined) {
                    if (errors.response.status === 401) {
                        setDadosModalMensagem({
                            acao: true,
                            label: "",
                            tipo: "info",
                            mensagem: "Sessão expirada!",
                            display: "none",
                            titulo: "Atenção"
                        });
                        logout();
                        setRedirecionar("0");
                        return;
                    }

                    setDadosModalMensagem({
                        acao: true,
                        label: "",
                        tipo: "error",
                        mensagem: errors.response.data.mensagem,
                        display: "none",
                        titulo: "Atenção"
                    });
                    setRedirecionar(`/usuario/liga/${codLocal}`);
                    return;
                }
                setDadosModalMensagem({
                    acao: true,
                    label: "",
                    tipo: "error",
                    mensagem: "Não foi possível carregar os dados da FA, favor tentar novamente mais tarde. Caso o problema continue, entrar em contato com a TI.",
                    display: "none",
                    titulo: "Atenção"
                });
                return;
            });

        await FreeagencyService.getAllRestritoPorCodigo(liga.codigo_Free_Agency, liga.codigo_Franquia)
            .then((result) => {
                const lstFreeAgencyRestrito = result.data.dado;
                setListaLanceFreeAgencyRestrito(lstFreeAgencyRestrito.filter(f => f.codigo === codigoLance));
                if (lstFreeAgencyRestrito.length > 0) {
                    let obj = lstFreeAgencyRestrito.sort((a, b) => Number(new Date(b.data_Fim_Lance)) - Number(new Date(a.data_Fim_Lance)));
                    setDataFimLance(obj[0].data_Fim_Lance);
                }
            })
            .catch((errors) => {
                setShowModalMensagem(true);
                setIsLoading(false);
                setRemoveLoading(true);
                if (errors.response !== undefined) {
                    if (errors.response.status === 401) {
                        setDadosModalMensagem({
                            acao: true,
                            label: "",
                            tipo: "info",
                            mensagem: "Sessão expirada!",
                            display: "none",
                            titulo: "Atenção"
                        });
                        logout();
                        setRedirecionar("0");
                        return;
                    }

                    setDadosModalMensagem({
                        acao: true,
                        label: "",
                        tipo: "error",
                        mensagem: errors.response.data.mensagem,
                        display: "none",
                        titulo: "Atenção"
                    });
                    setRedirecionar(`/usuario/liga/${codLocal}`);
                    return;
                }
                setDadosModalMensagem({
                    acao: true,
                    label: "",
                    tipo: "error",
                    mensagem: "Não foi possível carregar os dados da FA, favor tentar novamente mais tarde. Caso o problema continue, entrar em contato com a TI.",
                    display: "none",
                    titulo: "Atenção"
                });
                return;
            });

        setRemoveLoading(true);
        setIsLoading(false);
    }

    const CarregarListaJogadores = async (atualizarAutoComplete: boolean) => {
        let posicao = posicaoFiltro === 0 ? "" : lstPosicoes.find(f => f.codigo === posicaoFiltro)?.label;
        await JogadorService.getAllPorLiga(Number(codigoLiga), selectedIdCompleteFiltro, posicao !== undefined ? posicao : "", codigofranquiaDireitoFiltro, codigofranquiaLanceFiltro)
            .then((result) => {
                setRows(result.data.dado);
                const resultado = result.data.dado;
                let lstDrop: TDropOptions[] = resultado
                    .map((f, i) => ({ codigo: f.codigo, label: f.nome, descricao: f.codigo_NBA.toString() }));

                setLstJogadores(lstDrop.sort((a, b) => a.label > b.label ? 1 : -1));
                if (atualizarAutoComplete === true) {
                    setOpcoesAutoCompleteJogador(lstDrop.sort((a, b) => a.label > b.label ? 1 : -1));
                    setOpcoesAutoCompleteJogadorFiltro(lstDrop.sort((a, b) => a.label > b.label ? 1 : -1));
                }

            }).catch((errors) => {
                setIsLoading(false);
                setShowModalMensagem(true);
                setRemoveLoading(true);
                if (errors.response !== undefined) {
                    if (errors.response.status === 401) {
                        setDadosModalMensagem({
                            acao: true,
                            label: "",
                            tipo: "info",
                            mensagem: "Sessão expirada!",
                            display: "none",
                            titulo: "Atenção"
                        });

                        logout();
                        setRedirecionar("0");
                        return;
                    }
                    setDadosModalMensagem({
                        acao: true,
                        label: "",
                        tipo: "error",
                        mensagem: errors.response.data.mensagem,
                        display: "none",
                        titulo: "Atenção"
                    });
                    return;
                }
                else {
                    setDadosModalMensagem({
                        acao: true,
                        label: "",
                        tipo: "error",
                        mensagem: "Não foi possível carregar os dados do jogador! Favor entrar em contato com a TI",
                        display: "none",
                        titulo: "Atenção"
                    });
                }
            });
    }

    const handleSave = async (dados: any) => {
        setDesativar(true);
        setIsLoading(true);
        setRemoveLoading(false);
        const liga = dadosLiga !== null && dadosLiga !== undefined ? dadosLiga : null;
        if (liga === null) {
            setDesativar(false);
            setShowModalMensagem(true);
            setDadosModalMensagem({
                acao: true,
                label: "",
                tipo: "warning",
                mensagem: "Favor selecionar uma liga!",
                display: "none",
                titulo: "Atenção"
            });
            setRedirecionar(`/usuario/liga/${codLocal}`);
            return;
        }
        if (selectedIdComplete === 0 || selectedIdComplete === undefined) {
            setDesativar(false);
            setShowModalMensagem(true);
            setDadosModalMensagem({
                acao: true,
                label: "",
                tipo: "warning",
                mensagem: "Favor selecionar o jogador!",
                display: "none",
                titulo: "Atenção"
            });
            setIsLoading(false);
            return;
        }

        if (valorSalarioJogador === "0" || valorSalarioJogador === undefined || valorSalarioJogador === "") {
            setDesativar(false);
            setShowModalMensagem(true);
            setDadosModalMensagem({
                acao: true,
                label: "",
                tipo: "warning",
                mensagem: "Favor informar o valor do salário!",
                display: "none",
                titulo: "Atenção"
            });
            setIsLoading(false);
            return;
        }

        if (anoSelecionado === 0 || anoSelecionado === undefined) {
            setDesativar(false);
            setShowModalMensagem(true);
            setDadosModalMensagem({
                acao: true,
                label: "",
                tipo: "warning",
                mensagem: "Favor selecionar o(s) ano(s)!",
                display: "none",
                titulo: "Atenção"
            });
            setIsLoading(false);
            return;
        }

        const dadosSalvar: IDetalheJogadorFreeAgency = {
            codigo_Franquia: liga?.codigo_Franquia,
            codigo_Free_Agency: liga?.codigo_Free_Agency,
            codigo_Jogador: Number(selectedIdComplete),
            tempo_Contrato: anoSelecionado,
            valor: valorSalarioJogador
        }

        JogadorService.CreateJogadorFreeAgency(dadosSalvar)
            .then((result) => {
                setIsLoading(false);
                setRemoveLoading(true);
                setShowModalMensagem(true);
                setDadosModalMensagem({
                    acao: true,
                    label: "",
                    tipo: "success",
                    mensagem: "Lance salvo com sucesso!",
                    display: "none",
                    titulo: "Atenção"
                });
                setRedirecionar("1");
            })
            .catch((errors) => {
                setIsLoading(false);
                setDesativar(false);
                setRemoveLoading(true);
                setShowModalMensagem(true);
                if (errors.response !== undefined) {
                    if (errors.response.status === 401) {
                        setDadosModalMensagem({
                            acao: true,
                            label: "",
                            tipo: "error",
                            mensagem: "Sessão expirada!",
                            display: "none",
                            titulo: "Atenção"
                        });
                        logout();
                        setRedirecionar("0");
                        return;
                    }
                    else {
                        setDadosModalMensagem({
                            acao: true,
                            label: "",
                            tipo: "error",
                            mensagem: errors.response.data.mensagem,
                            display: "none",
                            titulo: "Atenção"
                        });
                        return;
                    }
                }
                setDadosModalMensagem({
                    acao: true,
                    label: "",
                    tipo: "error",
                    mensagem: "Não foi possível cadastrar os dados do lance! Favor entrar em contato com a TI.",
                    display: "none",
                    titulo: "Atenção"
                });
            });
    }

    const handleDelete = (id: number) => {
        if (window.confirm("Realmente deseja apagar?")) {
            // FranquiaService.deleteById(id)
            //     .then((result) => {
            //         setShowModalMensagem(true);
            //         setDadosModalMensagem({
            //             acao: true,
            //             label: "",
            //             tipo: "success",
            //             mensagem: "Registro excluido com sucesso!",
            //             display: "none",
            //             titulo: "Atenção"
            //         });
            //         setRedirecionar("/franquias");
            //     })
            //     .catch((errors) => {
            //         setShowModalMensagem(true);
            //         if (errors.response.data.statusHTTP === 401) {
            //             logout();
            //             setDadosModalMensagem({
            //                 acao: true,
            //                 label: "",
            //                 tipo: "error",
            //                 mensagem: "Sessão expirada!",
            //                 display: "none",
            //                 titulo: "Atenção"
            //             });
            //             setRedirecionar("0");;
            //             return;
            //         }
            //         setDadosModalMensagem({
            //             acao: true,
            //             label: "",
            //             tipo: "error",
            //             mensagem: errors.response.data.mensagem,
            //             display: "none",
            //             titulo: "Atenção"
            //         });
            //     });
        }
    }

    const toggleModalEvent = () => {
        setShowModalEvent(modalVisivel => !modalVisivel);
        redirecionar.length === 1 || CookieService.get("access_token") === undefined ? navigate(0) : navigate(redirecionar);
    }

    const toggleModalMensagem = () => {
        setShowModalMensagem(modalVisivel => !modalVisivel);
        redirecionar.length === 1 ? navigate(0) : navigate(redirecionar);
    }

    const handleChangeTabs = (event: React.SyntheticEvent, newValue: number) => {
        setValue(newValue);
    };

    const handleAcaoLeilao = (dadoLance: IListaDadosLanceFreeAgency, codigoFranquiaAtual: number, tipoFreeAgency: number = 1, codigoTipoPosicaoConfronto: number = 1, porcentagemContratoAjustavel: number = 0) => {
        setShowModalEvent(true);

        //let dadosLance = listaLanceFreeAgency.find(f => f.codigo === codigoLance);
        setDadosModalEvent({
            acao: true,
            label: "Aumentar",
            tipo: "info",
            mensagem: `Deseja aumentar a oferta do leilão? `,
            display: "none",
            titulo: "Leilão Free Agency",
            evento: "lanceFreeAgency",
            info: {
                dadosLance: dadoLance,
                codigoFranquia: codigoFranquiaAtual,
                tipoFreeAgency: tipoFreeAgency,
                codigoTipoPosicaoConfronto: codigoTipoPosicaoConfronto,
                porcentagemContratoAjustavel: porcentagemContratoAjustavel,
                style: { color: "red", fontWeight: "bold", wordWrap: "break-word", whiteSpace: "pre-line" }
            }
        });
    }

    const handleContratar = async (params: any) => {
        let dados: IDadosContratacaoFreeAgency = {
            codigo: params.codigo,
            codigo_Franquia: codigoFranquia,
            codigo_Jogador: params.codigo_Jogador,
            codigo_Free_Agency: params.codigo_Free_Agency,
            codUsuCriacao: user.codUsuario
        }
        await FreeagencyService.createContratarFreeAgency(dados)
            .then((result) => {
                setIsLoading(false);
                setShowModalMensagem(true);
                setDadosModalMensagem({
                    acao: true,
                    label: "",
                    tipo: "success",
                    mensagem: `${params.nome_Jogador} mantido na sua franquia!`,
                    display: "none",
                    titulo: "Sucesso"
                });
                setRedirecionar("0");
            })
            .catch((errors) => {
                setShowModalMensagem(true);
                setRemoveLoading(true);
                if (errors.response !== undefined) {
                    if (errors.response.status === 401) {
                        setDadosModalMensagem({
                            acao: true,
                            label: "",
                            tipo: "info",
                            mensagem: "Sessão expirada!",
                            display: "none",
                            titulo: "Atenção"
                        });
                        logout();
                        setRedirecionar("0");
                        return;
                    }
                    setDadosModalMensagem({
                        acao: true,
                        label: "",
                        tipo: "error",
                        mensagem: errors.response.data.mensagem,
                        display: "none",
                        titulo: "Atenção"
                    });
                    return;
                }
                setDadosModalMensagem({
                    acao: true,
                    label: "",
                    tipo: "error",
                    mensagem: "Não foi possível salvar os dados FA, favor tentar novamente mais tarde. Caso o problema continue, entrar em contato com a TI.",
                    display: "none",
                    titulo: "Atenção"
                });
                return;
            });
    }

    const handleRecusarContrato = async (params: any) => {
        let dados: IDadosContratacaoFreeAgency = {
            codigo: params.codigo,
            codigo_Franquia: codigoFranquia,
            codigo_Jogador: params.codigo_Jogador,
            codigo_Free_Agency: params.codigo_Free_Agency,
            codUsuCriacao: user.codUsuario
        }
        await FreeagencyService.updateRecusarContratoFreeAgency(dados)
            .then((result) => {
                setIsLoading(false);
                setShowModalMensagem(true);
                setDadosModalMensagem({
                    acao: true,
                    label: "",
                    tipo: "success",
                    mensagem: `${params.nome_Jogador} dispensado de sua franquia!`,
                    display: "none",
                    titulo: "Sucesso"
                });
                setRedirecionar("0");
            })
            .catch((errors) => {
                setShowModalMensagem(true);
                setRemoveLoading(true);
                if (errors.response !== undefined) {
                    if (errors.response.status === 401) {
                        setDadosModalMensagem({
                            acao: true,
                            label: "",
                            tipo: "info",
                            mensagem: "Sessão expirada!",
                            display: "none",
                            titulo: "Atenção"
                        });
                        logout();
                        setRedirecionar("0");
                        return;
                    }
                    setDadosModalMensagem({
                        acao: true,
                        label: "",
                        tipo: "error",
                        mensagem: errors.response.data.mensagem,
                        display: "none",
                        titulo: "Atenção"
                    });
                    return;
                }
                setDadosModalMensagem({
                    acao: true,
                    label: "",
                    tipo: "error",
                    mensagem: "Não foi possível cancelar o lance da FA, favor tentar novamente mais tarde. Caso o problema continue, entrar em contato com a TI.",
                    display: "none",
                    titulo: "Atenção"
                });
                return;
            });
    }

    const freeAgencyRestritoColumns: GridColDef[] = [
        // { field: 'codigo', headerName: 'CÓDIGO', width: 90, headerClassName: 'super-app-theme--header',  },
        {
            field: 'foto_Jogador',
            headerName: 'FOTO',
            flex: 1,
            editable: false,
            headerClassName: 'super-app-theme--header',
            renderCell: (params) => (params.value !== null && params.value !== "" && params.value !== undefined)
                ? <img src={params.value} width={UtilidadeService.isMobile() ? 35 : 50} height={UtilidadeService.isMobile() ? 35 : 50}
                    onError={({ currentTarget }) => {
                        currentTarget.onerror = null;
                        currentTarget.src = "../../../../semimagem.png";
                        currentTarget.style.borderRadius = "50%";
                        currentTarget.style.width = UtilidadeService.isMobile() ? "30px" : "40px";
                        currentTarget.style.height = UtilidadeService.isMobile() ? "30px" : "40px";
                    }} />
                : <img src={"../../../../semimagem.png"} width={UtilidadeService.isMobile() ? 30 : 40} height={UtilidadeService.isMobile() ? 30 : 40} style={{ borderRadius: "50%" }} />,
        },
        {
            field: 'nome_Jogador',
            headerName: 'JOGADOR',
            editable: false,
            flex: 1,
            headerClassName: 'super-app-theme--header',

        },
        {
            field: 'posicao_Jogador_1',
            headerName: 'POSIÇÃO',
            headerClassName: 'super-app-theme--header',
            width: 150,
            editable: false,
            renderCell: (params) => carregaPosicao(params.row.posicao_Jogador_1, params.row.posicao_Jogador_2, params.row.posicao_Jogador_3),
            align: 'center',
            headerAlign: 'center'
        },
        {
            field: 'valor_Ultimo_Contrato_Jogador',
            headerName: 'ÚLT. CONTRATO',
            editable: false,
            headerClassName: 'super-app-theme--header',
            flex: 1
        },
        {
            field: 'franquia_Lance_Jogador',
            headerName: 'FRANQUIA',
            editable: false,
            headerClassName: 'super-app-theme--header',
            flex: 1
        },
        {
            field: 'valor',
            headerName: 'VALOR',
            editable: false,
            headerClassName: 'super-app-theme--header',
            flex: 1,
            valueFormatter: (params) => `R$${moedaRealLocaleValue(params.value)}`,
        },
        {
            field: 'valor_Desconto',
            headerName: 'DESCONTO',
            editable: false,
            headerClassName: 'super-app-theme--header',
            flex: 1,
            valueFormatter: (params) => `R$${moedaRealLocaleValue(params.value)}`,
        },
        {
            field: 'data_Fim_Lance',
            headerName: 'DATA FIM',
            editable: false,

            headerClassName: 'super-app-theme--header',
            flex: 1,
            valueFormatter: (params) => dayjs(params.value).format('DD/MM/YYYY HH:mm'),
        },
        {
            field: 'actions',
            headerName: 'AÇÃO',
            headerClassName: 'super-app-theme--header',
            type: 'actions',
            width: 80,
            getActions: (params) => [
                <GridActionsCellItem
                    icon={<Tooltip title="Contratar"><AddTask sx={{ color: "#66bb6a" }} /></Tooltip>}
                    label="Contratar"
                    onClick={() => handleContratar(params.row)}
                />,
                <GridActionsCellItem
                    icon={<Tooltip title="Recusar"><Icon sx={{ color: "#E91309" }}>cancel</Icon></Tooltip>}
                    label="Recusar"
                    onClick={() => handleRecusarContrato(params.row)}
                />
            ]
        }
    ];

    //#region variaveis


    const [hora0, setHora0] = useState<number>(0);
    const [minuto0, setMinuto0] = useState<number>(0);
    const [segundo0, setSegundo0] = useState<number>(0);

    const [hora1, setHora1] = useState<number>(0);
    const [minuto1, setMinuto1] = useState<number>(0);
    const [segundo1, setSegundo1] = useState<number>(0);

    const [hora2, setHora2] = useState<number>(0);
    const [minuto2, setMinuto2] = useState<number>(0);
    const [segundo2, setSegundo2] = useState<number>(0);

    const [hora3, setHora3] = useState<number>(0);
    const [minuto3, setMinuto3] = useState<number>(0);
    const [segundo3, setSegundo3] = useState<number>(0);

    const [hora4, setHora4] = useState<number>(0);
    const [minuto4, setMinuto4] = useState<number>(0);
    const [segundo4, setSegundo4] = useState<number>(0);

    const [hora5, setHora5] = useState<number>(0);
    const [minuto5, setMinuto5] = useState<number>(0);
    const [segundo5, setSegundo5] = useState<number>(0);

    const [hora6, setHora6] = useState<number>(0);
    const [minuto6, setMinuto6] = useState<number>(0);
    const [segundo6, setSegundo6] = useState<number>(0);

    const [hora7, setHora7] = useState<number>(0);
    const [minuto7, setMinuto7] = useState<number>(0);
    const [segundo7, setSegundo7] = useState<number>(0);

    const [hora8, setHora8] = useState<number>(0);
    const [minuto8, setMinuto8] = useState<number>(0);
    const [segundo8, setSegundo8] = useState<number>(0);

    const [hora9, setHora9] = useState<number>(0);
    const [minuto9, setMinuto9] = useState<number>(0);
    const [segundo9, setSegundo9] = useState<number>(0);

    const [hora10, setHora10] = useState<number>(0);
    const [minuto10, setMinuto10] = useState<number>(0);
    const [segundo10, setSegundo10] = useState<number>(0);

    const [hora11, setHora11] = useState<number>(0);
    const [minuto11, setMinuto11] = useState<number>(0);
    const [segundo11, setSegundo11] = useState<number>(0);

    const [hora12, setHora12] = useState<number>(0);
    const [minuto12, setMinuto12] = useState<number>(0);
    const [segundo12, setSegundo12] = useState<number>(0);

    const [hora13, setHora13] = useState<number>(0);
    const [minuto13, setMinuto13] = useState<number>(0);
    const [segundo13, setSegundo13] = useState<number>(0);

    const [hora14, setHora14] = useState<number>(0);
    const [minuto14, setMinuto14] = useState<number>(0);
    const [segundo14, setSegundo14] = useState<number>(0);

    const [hora15, setHora15] = useState<number>(0);
    const [minuto15, setMinuto15] = useState<number>(0);
    const [segundo15, setSegundo15] = useState<number>(0);

    const [hora16, setHora16] = useState<number>(0);
    const [minuto16, setMinuto16] = useState<number>(0);
    const [segundo16, setSegundo16] = useState<number>(0);

    const [hora17, setHora17] = useState<number>(0);
    const [minuto17, setMinuto17] = useState<number>(0);
    const [segundo17, setSegundo17] = useState<number>(0);

    const [hora18, setHora18] = useState<number>(0);
    const [minuto18, setMinuto18] = useState<number>(0);
    const [segundo18, setSegundo18] = useState<number>(0);

    const [hora19, setHora19] = useState<number>(0);
    const [minuto19, setMinuto19] = useState<number>(0);
    const [segundo19, setSegundo19] = useState<number>(0);

    const [hora20, setHora20] = useState<number>(0);
    const [minuto20, setMinuto20] = useState<number>(0);
    const [segundo20, setSegundo20] = useState<number>(0);

    const [hora21, setHora21] = useState<number>(0);
    const [minuto21, setMinuto21] = useState<number>(0);
    const [segundo21, setSegundo21] = useState<number>(0);

    const [hora22, setHora22] = useState<number>(0);
    const [minuto22, setMinuto22] = useState<number>(0);
    const [segundo22, setSegundo22] = useState<number>(0);

    const [hora23, setHora23] = useState<number>(0);
    const [minuto23, setMinuto23] = useState<number>(0);
    const [segundo23, setSegundo23] = useState<number>(0);

    const [hora24, setHora24] = useState<number>(0);
    const [minuto24, setMinuto24] = useState<number>(0);
    const [segundo24, setSegundo24] = useState<number>(0);

    const [hora25, setHora25] = useState<number>(0);
    const [minuto25, setMinuto25] = useState<number>(0);
    const [segundo25, setSegundo25] = useState<number>(0);

    const [hora26, setHora26] = useState<number>(0);
    const [minuto26, setMinuto26] = useState<number>(0);
    const [segundo26, setSegundo26] = useState<number>(0);

    const [hora27, setHora27] = useState<number>(0);
    const [minuto27, setMinuto27] = useState<number>(0);
    const [segundo27, setSegundo27] = useState<number>(0);

    const [hora28, setHora28] = useState<number>(0);
    const [minuto28, setMinuto28] = useState<number>(0);
    const [segundo28, setSegundo28] = useState<number>(0);

    const [hora29, setHora29] = useState<number>(0);
    const [minuto29, setMinuto29] = useState<number>(0);
    const [segundo29, setSegundo29] = useState<number>(0);

    const [hora30, setHora30] = useState<number>(0);
    const [minuto30, setMinuto30] = useState<number>(0);
    const [segundo30, setSegundo30] = useState<number>(0);

    const [hora31, setHora31] = useState<number>(0);
    const [minuto31, setMinuto31] = useState<number>(0);
    const [segundo31, setSegundo31] = useState<number>(0);

    const [hora32, setHora32] = useState<number>(0);
    const [minuto32, setMinuto32] = useState<number>(0);
    const [segundo32, setSegundo32] = useState<number>(0);

    const [hora33, setHora33] = useState<number>(0);
    const [minuto33, setMinuto33] = useState<number>(0);
    const [segundo33, setSegundo33] = useState<number>(0);

    const [hora34, setHora34] = useState<number>(0);
    const [minuto34, setMinuto34] = useState<number>(0);
    const [segundo34, setSegundo34] = useState<number>(0);

    const [hora35, setHora35] = useState<number>(0);
    const [minuto35, setMinuto35] = useState<number>(0);
    const [segundo35, setSegundo35] = useState<number>(0);

    const [hora36, setHora36] = useState<number>(0);
    const [minuto36, setMinuto36] = useState<number>(0);
    const [segundo36, setSegundo36] = useState<number>(0);

    const [hora37, setHora37] = useState<number>(0);
    const [minuto37, setMinuto37] = useState<number>(0);
    const [segundo37, setSegundo37] = useState<number>(0);

    const [hora38, setHora38] = useState<number>(0);
    const [minuto38, setMinuto38] = useState<number>(0);
    const [segundo38, setSegundo38] = useState<number>(0);

    const [hora39, setHora39] = useState<number>(0);
    const [minuto39, setMinuto39] = useState<number>(0);
    const [segundo39, setSegundo39] = useState<number>(0);

    const [hora40, setHora40] = useState<number>(0);
    const [minuto40, setMinuto40] = useState<number>(0);
    const [segundo40, setSegundo40] = useState<number>(0);

    const [hora41, setHora41] = useState<number>(0);
    const [minuto41, setMinuto41] = useState<number>(0);
    const [segundo41, setSegundo41] = useState<number>(0);

    const [hora42, setHora42] = useState<number>(0);
    const [minuto42, setMinuto42] = useState<number>(0);
    const [segundo42, setSegundo42] = useState<number>(0);

    const [hora43, setHora43] = useState<number>(0);
    const [minuto43, setMinuto43] = useState<number>(0);
    const [segundo43, setSegundo43] = useState<number>(0);

    const [hora44, setHora44] = useState<number>(0);
    const [minuto44, setMinuto44] = useState<number>(0);
    const [segundo44, setSegundo44] = useState<number>(0);

    const [hora45, setHora45] = useState<number>(0);
    const [minuto45, setMinuto45] = useState<number>(0);
    const [segundo45, setSegundo45] = useState<number>(0);

    const [hora46, setHora46] = useState<number>(0);
    const [minuto46, setMinuto46] = useState<number>(0);
    const [segundo46, setSegundo46] = useState<number>(0);

    const [hora47, setHora47] = useState<number>(0);
    const [minuto47, setMinuto47] = useState<number>(0);
    const [segundo47, setSegundo47] = useState<number>(0);

    const [hora48, setHora48] = useState<number>(0);
    const [minuto48, setMinuto48] = useState<number>(0);
    const [segundo48, setSegundo48] = useState<number>(0);

    const [hora49, setHora49] = useState<number>(0);
    const [minuto49, setMinuto49] = useState<number>(0);
    const [segundo49, setSegundo49] = useState<number>(0);

    const [hora50, setHora50] = useState<number>(0);
    const [minuto50, setMinuto50] = useState<number>(0);
    const [segundo50, setSegundo50] = useState<number>(0);

    const [hora51, setHora51] = useState<number>(0);
    const [minuto51, setMinuto51] = useState<number>(0);
    const [segundo51, setSegundo51] = useState<number>(0);

    const [hora52, setHora52] = useState<number>(0);
    const [minuto52, setMinuto52] = useState<number>(0);
    const [segundo52, setSegundo52] = useState<number>(0);

    const [hora53, setHora53] = useState<number>(0);
    const [minuto53, setMinuto53] = useState<number>(0);
    const [segundo53, setSegundo53] = useState<number>(0);

    const [hora54, setHora54] = useState<number>(0);
    const [minuto54, setMinuto54] = useState<number>(0);
    const [segundo54, setSegundo54] = useState<number>(0);

    const [hora55, setHora55] = useState<number>(0);
    const [minuto55, setMinuto55] = useState<number>(0);
    const [segundo55, setSegundo55] = useState<number>(0);

    const [hora56, setHora56] = useState<number>(0);
    const [minuto56, setMinuto56] = useState<number>(0);
    const [segundo56, setSegundo56] = useState<number>(0);

    const [hora57, setHora57] = useState<number>(0);
    const [minuto57, setMinuto57] = useState<number>(0);
    const [segundo57, setSegundo57] = useState<number>(0);

    const [hora58, setHora58] = useState<number>(0);
    const [minuto58, setMinuto58] = useState<number>(0);
    const [segundo58, setSegundo58] = useState<number>(0);

    const [hora59, setHora59] = useState<number>(0);
    const [minuto59, setMinuto59] = useState<number>(0);
    const [segundo59, setSegundo59] = useState<number>(0);

    const [hora60, setHora60] = useState<number>(0);
    const [minuto60, setMinuto60] = useState<number>(0);
    const [segundo60, setSegundo60] = useState<number>(0);

    const [hora61, setHora61] = useState<number>(0);
    const [minuto61, setMinuto61] = useState<number>(0);
    const [segundo61, setSegundo61] = useState<number>(0);

    const [hora62, setHora62] = useState<number>(0);
    const [minuto62, setMinuto62] = useState<number>(0);
    const [segundo62, setSegundo62] = useState<number>(0);

    const [hora63, setHora63] = useState<number>(0);
    const [minuto63, setMinuto63] = useState<number>(0);
    const [segundo63, setSegundo63] = useState<number>(0);

    const [hora64, setHora64] = useState<number>(0);
    const [minuto64, setMinuto64] = useState<number>(0);
    const [segundo64, setSegundo64] = useState<number>(0);

    const [hora65, setHora65] = useState<number>(0);
    const [minuto65, setMinuto65] = useState<number>(0);
    const [segundo65, setSegundo65] = useState<number>(0);

    const [hora66, setHora66] = useState<number>(0);
    const [minuto66, setMinuto66] = useState<number>(0);
    const [segundo66, setSegundo66] = useState<number>(0);

    const [hora67, setHora67] = useState<number>(0);
    const [minuto67, setMinuto67] = useState<number>(0);
    const [segundo67, setSegundo67] = useState<number>(0);

    const [hora68, setHora68] = useState<number>(0);
    const [minuto68, setMinuto68] = useState<number>(0);
    const [segundo68, setSegundo68] = useState<number>(0);

    const [hora69, setHora69] = useState<number>(0);
    const [minuto69, setMinuto69] = useState<number>(0);
    const [segundo69, setSegundo69] = useState<number>(0);

    const [hora70, setHora70] = useState<number>(0);
    const [minuto70, setMinuto70] = useState<number>(0);
    const [segundo70, setSegundo70] = useState<number>(0);

    const [hora71, setHora71] = useState<number>(0);
    const [minuto71, setMinuto71] = useState<number>(0);
    const [segundo71, setSegundo71] = useState<number>(0);

    const [hora72, setHora72] = useState<number>(0);
    const [minuto72, setMinuto72] = useState<number>(0);
    const [segundo72, setSegundo72] = useState<number>(0);

    const [hora73, setHora73] = useState<number>(0);
    const [minuto73, setMinuto73] = useState<number>(0);
    const [segundo73, setSegundo73] = useState<number>(0);

    const [hora74, setHora74] = useState<number>(0);
    const [minuto74, setMinuto74] = useState<number>(0);
    const [segundo74, setSegundo74] = useState<number>(0);

    const [hora75, setHora75] = useState<number>(0);
    const [minuto75, setMinuto75] = useState<number>(0);
    const [segundo75, setSegundo75] = useState<number>(0);

    const [hora76, setHora76] = useState<number>(0);
    const [minuto76, setMinuto76] = useState<number>(0);
    const [segundo76, setSegundo76] = useState<number>(0);

    const [hora77, setHora77] = useState<number>(0);
    const [minuto77, setMinuto77] = useState<number>(0);
    const [segundo77, setSegundo77] = useState<number>(0);

    const [hora78, setHora78] = useState<number>(0);
    const [minuto78, setMinuto78] = useState<number>(0);
    const [segundo78, setSegundo78] = useState<number>(0);

    const [hora79, setHora79] = useState<number>(0);
    const [minuto79, setMinuto79] = useState<number>(0);
    const [segundo79, setSegundo79] = useState<number>(0);

    const [hora80, setHora80] = useState<number>(0);
    const [minuto80, setMinuto80] = useState<number>(0);
    const [segundo80, setSegundo80] = useState<number>(0);

    const [hora81, setHora81] = useState<number>(0);
    const [minuto81, setMinuto81] = useState<number>(0);
    const [segundo81, setSegundo81] = useState<number>(0);

    const [hora82, setHora82] = useState<number>(0);
    const [minuto82, setMinuto82] = useState<number>(0);
    const [segundo82, setSegundo82] = useState<number>(0);

    const [hora83, setHora83] = useState<number>(0);
    const [minuto83, setMinuto83] = useState<number>(0);
    const [segundo83, setSegundo83] = useState<number>(0);

    const [hora84, setHora84] = useState<number>(0);
    const [minuto84, setMinuto84] = useState<number>(0);
    const [segundo84, setSegundo84] = useState<number>(0);

    const [hora85, setHora85] = useState<number>(0);
    const [minuto85, setMinuto85] = useState<number>(0);
    const [segundo85, setSegundo85] = useState<number>(0);

    const [hora86, setHora86] = useState<number>(0);
    const [minuto86, setMinuto86] = useState<number>(0);
    const [segundo86, setSegundo86] = useState<number>(0);

    const [hora87, setHora87] = useState<number>(0);
    const [minuto87, setMinuto87] = useState<number>(0);
    const [segundo87, setSegundo87] = useState<number>(0);

    const [hora88, setHora88] = useState<number>(0);
    const [minuto88, setMinuto88] = useState<number>(0);
    const [segundo88, setSegundo88] = useState<number>(0);

    const [hora89, setHora89] = useState<number>(0);
    const [minuto89, setMinuto89] = useState<number>(0);
    const [segundo89, setSegundo89] = useState<number>(0);

    const [hora90, setHora90] = useState<number>(0);
    const [minuto90, setMinuto90] = useState<number>(0);
    const [segundo90, setSegundo90] = useState<number>(0);

    const [hora91, setHora91] = useState<number>(0);
    const [minuto91, setMinuto91] = useState<number>(0);
    const [segundo91, setSegundo91] = useState<number>(0);

    const [hora92, setHora92] = useState<number>(0);
    const [minuto92, setMinuto92] = useState<number>(0);
    const [segundo92, setSegundo92] = useState<number>(0);

    const [hora93, setHora93] = useState<number>(0);
    const [minuto93, setMinuto93] = useState<number>(0);
    const [segundo93, setSegundo93] = useState<number>(0);

    const [hora94, setHora94] = useState<number>(0);
    const [minuto94, setMinuto94] = useState<number>(0);
    const [segundo94, setSegundo94] = useState<number>(0);

    const [hora95, setHora95] = useState<number>(0);
    const [minuto95, setMinuto95] = useState<number>(0);
    const [segundo95, setSegundo95] = useState<number>(0);

    const [hora96, setHora96] = useState<number>(0);
    const [minuto96, setMinuto96] = useState<number>(0);
    const [segundo96, setSegundo96] = useState<number>(0);

    const [hora97, setHora97] = useState<number>(0);
    const [minuto97, setMinuto97] = useState<number>(0);
    const [segundo97, setSegundo97] = useState<number>(0);

    const [hora98, setHora98] = useState<number>(0);
    const [minuto98, setMinuto98] = useState<number>(0);
    const [segundo98, setSegundo98] = useState<number>(0);

    const [hora99, setHora99] = useState<number>(0);
    const [minuto99, setMinuto99] = useState<number>(0);
    const [segundo99, setSegundo99] = useState<number>(0);
    //#endregion

    const UseDiff = (data: Date, i: number, color: string) => {
        let now = moment.tz('America/Sao_Paulo').format('YYYY-MM-DD HH:mm:ss')
        const distance = moment(data).diff(now);
        const second = 1000;
        const minute = second * 60;
        const hour = minute * 60;
        const day = hour * 24;

        var hourNumber = Math.floor(distance / (1000 * 60 * 60));
        var minuteNumber = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        var secondNumber = Math.floor((distance % (1000 * 60)) / 1000);

        if (hourNumber >= 0 && minuteNumber >= 0 && secondNumber >= 0) {
            //setDia(dayNumber);
            eval(`setHora${i}`)(hourNumber)
            eval(`setMinuto${i}`)(minuteNumber)
            eval(`setSegundo${i}`)(secondNumber)
        }
        else {
            eval(`setHora${i}`)(0)
            eval(`setMinuto${i}`)(0)
            eval(`setSegundo${i}`)(0)
        }

        return (
            <Grid key={i} style={{ color: color }}>
                <span>{eval(`hora${i}`).toString().padStart(2, "0")}</span>
                <span>:</span>
                <span>{eval(`minuto${i}`).toString().padStart(2, "0")}</span>
                <span>:</span>
                <span>{eval(`segundo${i}`).toString().padStart(2, "0")}</span>
            </Grid>
        )
    }

    const UseCountdown = (date: Date, i: number, color: string) => {

        const interval = setInterval((ind: number = i) => {
            let now = moment.tz('America/Sao_Paulo').format('YYYY-MM-DD HH:mm:ss')
            const distance = moment(date).diff(now);
            const second = 1000;
            const minute = second * 60;
            const hour = minute * 60;
            const day = hour * 24;

            var hourNumber = Math.floor(distance / (1000 * 60 * 60));
            var minuteNumber = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
            var secondNumber = Math.floor((distance % (1000 * 60)) / 1000);

            if (hourNumber >= 0 && minuteNumber >= 0 && secondNumber >= 0) {
                //setDia(dayNumber);
                eval(`setHora${i}`)(hourNumber)
                eval(`setMinuto${i}`)(minuteNumber)
                eval(`setSegundo${i}`)(secondNumber)
            }
            else {
                eval(`setHora${i}`)(0)
                eval(`setMinuto${i}`)(0)
                eval(`setSegundo${i}`)(0)
            }

            if (distance < 0) {
                clearInterval(interval);
            }
        }, 900);
        return (
            <Grid key={i} style={{ color: color }}>
                <span>{eval(`hora${i}`).toString().padStart(2, "0")}</span>
                <span>:</span>
                <span>{eval(`minuto${i}`).toString().padStart(2, "0")}</span>
                <span>:</span>
                <span>{eval(`segundo${i}`).toString().padStart(2, "0")}</span>
            </Grid>
        )

    }

    const handleCalculartempo = (data: Date) => {
        //let now = moment();
        //let newDate = moment(data); 
        let now = moment().tz('America/Sao_Paulo');
        let newDate = moment(data).tz('America/Sao_Paulo');

        var ms = moment(newDate).diff(now.format());
        var d = moment.duration(ms);
        var h = Math.floor(d.asHours());

        if (h < 1) {
            return 1;
        }
        else if (h >= 1 && h < 6) {
            return 2;
        }
        else {
            return 3;
        }
    }

    const handleLimparFiltros = () => {
        setSelectedIdCompleteFiltro(0);
        setCodigofranquiaDireitoFiltro(0);
        setPosicaoFiltro(0);
        setCodigofranquiaLanceFiltro(0);
        setShowBotaoCancelar(false);
        setLimparFiltros(true);
    }

    const columns: GridColDef[] = [
        {
            field: 'codigo',
            headerName: 'ID',
            flex: 1,
            sortable: UtilidadeService.isMobile() ? false : true,
            minWidth: UtilidadeService.isMobile() ? 40 : 65,
            headerClassName: 'super-app-theme--header',
            align: 'center',
            headerAlign: 'center'
        },
        {
            field: 'foto',
            headerName: 'FOTO',
            flex: 1,
            sortable: false,
            minWidth: 60,
            renderCell: (params) => (params.value !== null && params.value !== "" && params.value !== undefined)
                ? <img src={params.value} width={UtilidadeService.isMobile() ? 35 : 50} height={UtilidadeService.isMobile() ? 35 : 50}
                    onError={({ currentTarget }) => {
                        currentTarget.onerror = null;
                        currentTarget.src = "../../../../semimagem.png";
                        currentTarget.style.borderRadius = "50%";
                        currentTarget.style.width = UtilidadeService.isMobile() ? "30px" : "40px";
                        currentTarget.style.height = UtilidadeService.isMobile() ? "30px" : "40px";
                    }} />
                : <img src={"../../../../semimagem.png"} width={UtilidadeService.isMobile() ? 30 : 40} height={UtilidadeService.isMobile() ? 30 : 40} style={{ borderRadius: "50%" }} />,
            headerClassName: 'super-app-theme--header',
            align: 'center',
            headerAlign: 'center'
        },

        {
            field: 'nome',
            headerName: 'JOGADOR',
            editable: false,
            flex: 1,
            sortable: UtilidadeService.isMobile() ? false : true,
            headerClassName: 'super-app-theme--header',
            minWidth: UtilidadeService.isMobile() ? 80 : 130,
            renderCell: (params) => {
                return (
                    <Box
                        sx={{
                            whiteSpace: 'pre-wrap',
                        }}
                    >
                        {params.value}
                        <span style={{ color: "#ED59BC" }}>
                            {
                                params.row.restrito === true && params.row.draftado === false ? " ®" :
                                    params.row.restrito === false && params.row.draftado === true ? <span style={{ color: "#59cbed" }}>&nbsp;Ð</span> :
                                        params.row.restrito === true && params.row.draftado === true ? <><span style={{ color: "#ED59BC" }}>&nbsp;®</span> <span style={{ color: "#59cbed" }}>&nbsp;Ð</span></> : ""
                            }
                        </span>
                    </Box>
                );
            },
            headerAlign: 'left',
            align: 'left'
        },
        {
            field: 'posicao_1',
            headerName: 'POSIÇÃO',
            headerClassName: 'super-app-theme--header',
            flex: 1,
            minWidth: 100,
            sortable: false,
            editable: false,
            renderCell: (params) => carregaPosicao(params.row.posicao_1, params.row.posicao_2, params.row.posicao_3),
            align: 'center',
            headerAlign: 'center'
        },
        {
            field: 'logo_Franquia_Direito_Liga',
            headerName: '',
            hideable: false,
            minWidth: UtilidadeService.isMobile() ? 45 : 60,
            // maxWidth: 65,
            flex: 1,
            renderCell: (params) => params.value !== null ? <img src={params.value === null ? showImagemFranquia : params.value} width={UtilidadeService.isMobile() ? 25 : 45} height={UtilidadeService.isMobile() ? 30 : 50} /> : null,
            headerClassName: 'super-app-theme--header',
            sortable: false,
            align: 'center',
            headerAlign: 'center',
        },
        {
            field: 'franquia_Direito_Liga',
            headerName: 'DIREITO',
            editable: false,
            headerClassName: 'super-app-theme--header',
            flex: 1,
            sortable: UtilidadeService.isMobile() ? false : true,
            minWidth: UtilidadeService.isMobile() ? 75 : 120,
            renderCell: (params) => {
                const color = params.row.codigo_Franquia_Direito_Liga !== codigoFranquia ? "auto" : "#4864E8";
                return (
                    <Box
                        sx={{
                            color: color,
                            fontWeight: 'bold',
                            whiteSpace: 'pre-wrap',
                        }}
                    >
                        {params.value}
                    </Box>
                );
            },
            align: 'left',
            headerAlign: 'left'
        },
        {
            field: 'tempo_Contrato_Ultimo_Lance',
            headerName: 'TEMPO',
            editable: false,
            headerClassName: 'super-app-theme--header',
            flex: 1,
            sortable: UtilidadeService.isMobile() ? false : true,
            minWidth: 70,
            align: 'center',
            headerAlign: 'center'
        },
        {
            field: 'valor_Ultimo_Lance',
            headerName: 'ÚLT LANCE',
            editable: false,
            headerClassName: 'super-app-theme--header',
            flex: 1,
            sortable: UtilidadeService.isMobile() ? false : true,
            minWidth: UtilidadeService.isMobile() ? 100 : 130,
            align: 'right',
            headerAlign: 'right',
            renderCell: (params) => formatNumber.format(params.value),

        },
        {
            field: 'logo_Franquia_Ultimo_Lance',
            headerName: '',
            hideable: false,
            minWidth: UtilidadeService.isMobile() ? 45 : 60,
            // maxWidth: 65,
            flex: 1,
            renderCell: (params) => params.value !== null ? <img src={params.value === null ? showImagemFranquia : params.value} width={UtilidadeService.isMobile() ? 30 : 50} height={UtilidadeService.isMobile() ? 30 : 50} /> : null,
            headerClassName: 'super-app-theme--header',
            sortable: false,
            align: 'center',
            headerAlign: 'center',
        },
        {
            field: 'franquia_Ultimo_Lance',
            headerName: 'LANCE',
            editable: false,
            headerClassName: 'super-app-theme--header',
            flex: 1,
            sortable: UtilidadeService.isMobile() ? false : true,
            minWidth: UtilidadeService.isMobile() ? 75 : 120,
            renderCell: (params) => {
                const color = params.row.codigo_Franquia_Ultimo_Lance !== codigoFranquia ? "auto" : "#4864E8";
                return (
                    <Box
                        sx={{
                            color: color,
                            fontWeight: 'bold',
                            whiteSpace: 'pre-wrap',
                        }}
                    >
                        {params.value}
                    </Box>
                );
            },
            align: 'left',
            headerAlign: 'left'
        },
        {
            field: 'quantidade_Lance_Jogador',
            headerName: 'QTD',
            editable: false,
            headerClassName: 'super-app-theme--header',
            flex: 1,
            sortable: UtilidadeService.isMobile() ? false : true,
            minWidth: 60,
            align: 'center',
            headerAlign: 'center'
        },
        {
            field: 'valor_Ultimo_Contrato',
            headerName: 'ÚLT CONTRATO',
            editable: false,
            headerClassName: 'super-app-theme--header',
            flex: 1,
            sortable: UtilidadeService.isMobile() ? false : true,
            minWidth: UtilidadeService.isMobile() ? 110 : 130,
            align: 'right',
            headerAlign: 'right',
            renderCell: (params) => formatNumber.format(params.value),
        },
        {
            field: 'valor_Media_Salarial',
            headerName: 'MÉD SALARIAL',
            editable: false,
            headerClassName: 'super-app-theme--header',
            flex: 1,
            sortable: UtilidadeService.isMobile() ? false : true,
            minWidth: UtilidadeService.isMobile() ? 110 : 130,
            align: 'right',
            headerAlign: 'right',
            renderCell: (params) => formatNumber.format(params.value),
        },
    ];

    const columnsTimes: GridColDef[] = [
        {
            field: 'codigo',
            headerName: 'ID',
            flex: 1,
            sortable: UtilidadeService.isMobile() ? false : true,
            width: 90,
            headerClassName: 'super-app-theme--header'
        },
        {
            field: 'logo',
            headerName: '',
            hideable: false,
            minWidth: UtilidadeService.isMobile() ? 45 : 65,
            // maxWidth: 65,
            flex: 1,
            renderCell: (params) =>
                <img src={params.value !== null ? params.value : showImagemFranquia} width={UtilidadeService.isMobile() ? 30 : 50} height={UtilidadeService.isMobile() ? 30 : 50} />,
            headerClassName: 'super-app-theme--header',
            sortable: false,
            align: 'center',
            headerAlign: 'center',
        },
        {
            field: 'nome',
            headerName: 'FRANQUIA',
            flex: 1,
            sortable: UtilidadeService.isMobile() ? false : true,
            minWidth: UtilidadeService.isMobile() ? 80 : 330,
            editable: false,
            headerClassName: 'super-app-theme--header',
            renderCell: (params) => {
                return (
                    <Box
                        sx={{
                            whiteSpace: UtilidadeService.isMobile() ? 'pre-wrap' : "nowrap",
                        }}
                    >
                        {params.value}
                    </Box>
                );
            },
        },
        {
            field: 'cap',
            headerName: 'CAP',
            flex: 1,
            sortable: UtilidadeService.isMobile() ? false : true,
            minWidth: 140,
            editable: false,
            headerClassName: 'super-app-theme--header',
            headerAlign: "center",
            align: "right",
            cellClassName: (params: GridCellParams<any, number>) => {

                if (params.value == null) {

                    return '';
                }

                return clsx('super-app', {
                    negative: parseFloat(params.value.toString()) < 0,
                    positive: parseFloat(params.value.toString()) >= 0,
                });
            },
            //valueGetter: (params: GridValueGetterParams) => formatNumber.format(params.row.cap),
            renderCell: (params) => formatNumber.format(params.row.cap),

        },
        {
            field: 'valor_Total_Lance',
            headerName: UtilidadeService.isMobile() ? 'VAL LANCE' : 'VALOR LANCE',
            flex: 1,
            sortable: UtilidadeService.isMobile() ? false : true,
            minWidth: UtilidadeService.isMobile() ? 110 : 130,
            editable: false,
            headerClassName: 'super-app-theme--header',
            headerAlign: "right",
            align: "right",
            cellClassName: (params: GridCellParams<any, number>) => {
                if (params.value == null) {
                    return '';
                }

                return clsx('super-app', {
                    negative: parseFloat(params.value.toString()) < 0,
                    positive: parseFloat(params.value.toString()) >= 0,
                });
            },
            //valueGetter: (params: GridValueGetterParams) => moedaRealLocaleValue(params.row.valor_Total_Lance)
            renderCell: (params) => formatNumber.format(params.row.valor_Total_Lance),

        },
        {
            field: 'cap_Disponivel',
            headerName: 'CAP FREE',
            flex: 1,
            sortable: UtilidadeService.isMobile() ? false : true,
            editable: false,
            minWidth: 140,
            headerClassName: 'super-app-theme--header',
            headerAlign: "right",
            align: "right",
            cellClassName: (params: GridCellParams<any, number>) => {
                if (params.value == null) {
                    return '';
                }

                return clsx('super-app', {
                    negative: parseFloat(params.value.toString()) < 0,
                    positive: parseFloat(params.value.toString()) >= 0,
                });
            },
            //valueGetter: (params: GridValueGetterParams) => moedaRealLocaleValue(params.row.cap_Disponivel)
            renderCell: (params) => formatNumber.format(params.row.cap_Disponivel),


        },
        {
            field: 'quantidade_Slot',
            headerName: 'SLOTS',
            flex: 1,
            sortable: UtilidadeService.isMobile() ? false : true,
            editable: false,
            minWidth: UtilidadeService.isMobile() ? 75 : 100,
            headerClassName: 'super-app-theme--header',
            align: "center",
            headerAlign: "center",

        },
        {
            field: 'quantidade_Lance',
            headerName: 'QTD. LANCE',
            flex: 1,
            sortable: UtilidadeService.isMobile() ? false : true,
            editable: false,
            minWidth: 90,
            headerClassName: 'super-app-theme--header',
            align: "center",
            headerAlign: "center",
        },
        {
            field: 'quantidade_Slot_Disponivel',
            headerName: 'SLOT DISPONÍVEL',
            flex: 1,
            sortable: UtilidadeService.isMobile() ? false : true,
            editable: false,
            minWidth: UtilidadeService.isMobile() ? 90 : 150,
            headerClassName: 'super-app-theme--header',
            align: "center",
            headerAlign: "center",

        },
    ];

    const columnsSalarios: GridColDef[] = [
        {
            field: 'codigo',
            headerName: 'ID',
            flex: 1,
            sortable: UtilidadeService.isMobile() ? false : true,
            width: 90,
            headerClassName: 'super-app-theme--header'
        },
        {
            field: 'valor_Minimo',
            headerName: UtilidadeService.isMobile() ? 'MIN VALOR' : 'MÍNIMO VALOR',
            flex: 1,
            editable: false,
            minWidth: 110,
            headerClassName: 'super-app-theme--header',
            headerAlign: "right",
            align: "right",
            cellClassName: (params: GridCellParams<any, number>) => {
                if (params.value == null) {
                    return '';
                }

                return clsx('super-app', {
                    negative: parseFloat(params.value.toString()) < 0,
                    positive: parseFloat(params.value.toString()) >= 0,
                });
            },

            //valueGetter: (params: GridValueGetterParams) =>  moedaRealLocaleValue(params.row.valor_Minimo)
            renderCell: (params) => `R$ ${moedaRealLocaleValue(params.row.valor_Minimo)}`,

        },
        {
            field: 'valor_Maximo',
            headerName: UtilidadeService.isMobile() ? 'MAX VALOR' : 'MÁXIMO VALOR',
            flex: 1,
            editable: false,
            minWidth: 110,
            sortable: UtilidadeService.isMobile() ? false : true,
            headerClassName: 'super-app-theme--header',
            headerAlign: "right",
            align: "right",
            cellClassName: (params: GridCellParams<any, number>) => {
                if (params.value == null) {
                    return '';
                }

                return clsx('super-app', {
                    negative: parseFloat(params.value.toString()) < 0,
                    positive: parseFloat(params.value.toString()) >= 0,
                });
            },
            //valueGetter: (params: GridValueGetterParams) => moedaRealLocaleValue(params.row.valor_Maximo)
            renderCell: (params) => `R$ ${moedaRealLocaleValue(params.row.valor_Maximo)}`,
        },
        {
            field: 'tempo_Minimo',
            headerName: UtilidadeService.isMobile() ? 'MIN DURAÇÃO' : 'MÍNIMO DURAÇÃO',
            flex: 1,
            editable: false,
            sortable: UtilidadeService.isMobile() ? false : true,
            minWidth: 110,
            headerClassName: 'super-app-theme--header',
            align: "center",
            headerAlign: "center",
        },
        {
            field: 'tempo_Maximo',
            headerName: UtilidadeService.isMobile() ? 'MAX DURAÇÃO' : 'MÁXIMO DURAÇÃO',
            flex: 1,
            editable: false,
            minWidth: 110,
            sortable: UtilidadeService.isMobile() ? false : true,
            headerClassName: 'super-app-theme--header',
            align: "center",
            headerAlign: "center",
        }
    ];

    return (
        <LayoutBaseDePagina
            titulo={`Dados Free Agency - ${dadosLiga?.nome}`}
            showLogoImg={dadosLiga?.caminho_Logo !== undefined ? dadosLiga?.caminho_Logo : showImagemFranquia}
            barraDeFerramentas={
                <FerramentasDeDetalhe
                    mostrarBotaoSalvar={false}
                    mostrarBotaoApagar={false}
                    mostrarBotaoSalvarEFechar={false}
                    mostrarBotaoNovo={false}
                    aoClicarEmSalvar={save}
                    aoClicarEmSalvarEFechar={saveAndClose}
                    aoClicarEmApagar={() => handleDelete(Number(codigoFranquia))}
                    aoClicarEmNovo={() => navigate("/freeagency/detalhe/nova")}
                    aoClicarEmVoltar={() => navigate("/liga/freeagency/detalhe")}
                />
            }
        >
            <VForm ref={formRef} onSubmit={handleSave}>
                <Box margin={1} display="flex" flexDirection="column" component={Paper} variant="outlined" style={{ padding: UtilidadeService.isMobile() ? 1 : 2 }}>
                    <Grid container direction="column" style={{ padding: UtilidadeService.isMobile() ? 1 : 2 }} spacing={2}>
                        <Grid container display="initial" alignItems="center" justifyContent="center" width="100%">
                            <Paper>
                                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                                    <Tabs value={value} onChange={handleChangeTabs}>
                                        <Tab label="Lance" disabled={novoLance} {...a11yProps(0)} />
                                        <Tab label="Jogadores" {...a11yProps(1)} />
                                        <Tab label="Times"  {...a11yProps(2)} />
                                        <Tab label="Salários"  {...a11yProps(3)} />
                                    </Tabs>
                                </Box>
                                <TabPanel value={value} index={0}>
                                    {aberturaFreeAgency ? (
                                        <Grid container size={{ xs: 12, sm: 12 }}>
                                            {!showGridFreeAgency && (
                                                <Grid container size={{ xs: 12, sm: 12 }} spacing={1} paddingBottom={3}>
                                                    {!removeLoading && isLoading && <Loading />}
                                                    <Grid container size={{ xs: 12, sm: 12, md: 12 }} marginTop={2} paddingTop={3}  >
                                                        {listaLanceFreeAgency.length > 0 && 
                                                            listaLanceFreeAgency.map((r, i) => (
                                                                UtilidadeService.isMobile() ?
                                                                    (
                                                                        <Card key={`Card${i}`} sx={{ border: "2px solid", borderColor: "#303134", m: UtilidadeService.isMobile() ? 0 : 1, width: "100%" }}>
                                                                            <CardContent sx={{ padding: 1, paddingBottom: 1, backgroundColor: "#252525", color: "white" }} >
                                                                                <Grid container size={{ xs: 12, sm: 4, md: 2 }} display="flex" justifyContent="center" textAlign="center" paddingBottom={1}>
                                                                                    <Grid size={{ xs: 6 }}>
                                                                                        <Typography variant="body2" style={{ fontSize: 13 }} sx={{ color: handleCalculartempo(r.data_Fim_Lance) <= 1 ? "red" : handleCalculartempo(r.data_Fim_Lance) === 2 ? "orange" : "white", }}>
                                                                                            Duração (Hrs):
                                                                                        </Typography>
                                                                                        {i <= 3 ? UseCountdown(r.data_Fim_Lance, i, handleCalculartempo(r.data_Fim_Lance) <= 1 ? "red" : handleCalculartempo(r.data_Fim_Lance) === 2 ? "orange" : "white") : UseDiff(r.data_Fim_Lance, i, handleCalculartempo(r.data_Fim_Lance) <= 1 ? "red" : handleCalculartempo(r.data_Fim_Lance) === 2 ? "orange" : "white")}
                                                                                    </Grid>
                                                                                    <Grid size={{ xs: 6 }}>
                                                                                        <Typography variant="body1" style={{ fontSize: 13 }}>
                                                                                            Tempo Final
                                                                                        </Typography>
                                                                                        <Typography variant="body2" style={{ fontSize: 12 }}>
                                                                                            {new Date(r.data_Fim_Lance).toLocaleDateString("pt-Br")} {new Date(r.data_Fim_Lance).toLocaleTimeString("pt-Br")}
                                                                                        </Typography>
                                                                                    </Grid>
                                                                                </Grid>
                                                                                <Grid size={{ xs: 12 }}>
                                                                                    <hr />
                                                                                </Grid>
                                                                                <Grid container size={{ xs: 12, sm: 12, md: 12 }} display="flex" >
                                                                                    <Grid size={{ xs: 2 }} display="flex" >
                                                                                        <img src={r.foto_Jogador} alt={r.nome_Jogador} width={50} height={50} />
                                                                                    </Grid>
                                                                                    <Grid container size={{ xs: 10 }} display="flex" >
                                                                                        <Grid size={{ xs: 12 }}>
                                                                                            <Typography key={`ty${i}2`} variant="body1" style={{ fontSize: 14 }}>
                                                                                                Jogador: {r.nome_Jogador} <span style={{ color: "#ED59BC" }}>{r.restrito_Jogador === true ? "®" : r.draftado === true ? <span style={{ color: "#6abdcb" }}>Ð</span> : ""}</span>
                                                                                            </Typography>
                                                                                        </Grid>
                                                                                        <Grid size={{ xs: 12 }}>
                                                                                            <Typography key={`ty${i}3`} variant="body1" style={{ fontSize: 14 }} >
                                                                                                Último Contrato: R${r.valor_Ultimo_Contrato_Jogador !== "0" ? moedaRealLocaleValue(r.valor_Ultimo_Contrato_Jogador) : r.valor_Ultimo_Contrato_Jogador}
                                                                                            </Typography>
                                                                                        </Grid>
                                                                                        <Grid size={{ xs: 12 }}>
                                                                                            <Typography key={`ty${i}4`} variant="body1" style={{ fontSize: 14, display: "flex", justifyContent: "flex-start" }}>
                                                                                                Posição: <span style={{ paddingLeft: "4px" }}>{carregaPosicao(r.posicao_Jogador_1, r.posicao_Jogador_2, r.posicao_Jogador_3)}</span>
                                                                                            </Typography>
                                                                                        </Grid>
                                                                                    </Grid>
                                                                                </Grid>
                                                                                <Grid container size={{ xs: 12, sm: 12, md: 12 }} display="flex" justifyContent={"center"} alignItems={"center"} textAlign={"center"}>
                                                                                    <Grid size={{ xs: 6 }} padding={1}  >
                                                                                        <Typography variant="body1" style={{ fontSize: 14, fontWeight: "bold" }}>
                                                                                            Valor Lance
                                                                                        </Typography>
                                                                                        <Typography variant="body2" style={{ fontSize: 14, fontWeight: "bold" }}>
                                                                                            R${moedaRealLocaleValue(r.valor)}
                                                                                        </Typography>
                                                                                    </Grid>
                                                                                    <Grid size={{ xs: 6 }} padding={1}  >
                                                                                        <Typography variant="body1" style={{ fontSize: 14 }}>
                                                                                            Contrato
                                                                                        </Typography>
                                                                                        <Typography variant="body2" style={{ fontSize: 14 }}>
                                                                                            {r.tempo_Contrato} Anos
                                                                                        </Typography>
                                                                                    </Grid>
                                                                                </Grid>
                                                                                <Grid container size={{ xs: 12, sm: 12, md: 12 }} display="flex" justifyContent={"center"} alignItems={"center"} >
                                                                                    <Grid container size={{ xs: 12, sm: 6, md: 3 }} display="flex"  >
                                                                                        <Grid container size={{ xs: 12, sm: 12, md: 12 }} display="flex" >
                                                                                            <Box width="100%" display="flex" flexDirection="row" justifyItems="center" alignItems="center">
                                                                                                <Grid container size={{ xs: 12, sm: 6, md: 6 }} display="flex" justifyContent="center" textAlign="center" direction="column">
                                                                                                    <Grid size={{ xs: 12, sm: 12 }}>
                                                                                                        <Typography variant="body1" style={{ fontSize: 14 }}>
                                                                                                            Franquia Lance
                                                                                                        </Typography>
                                                                                                        <Typography variant="body2" style={{ fontSize: 13 }}>
                                                                                                            <span style={{ color: r.codigo_Franquia === codigoFranquia ? "#66bb6a" : "white" }}> {r.franquia_Lance_Jogador}</span>
                                                                                                        </Typography>
                                                                                                        <img src={r.logo_Franquia_Lance_Jogador === null ? showImagemFranquia : r.logo_Franquia_Lance_Jogador} alt={r.franquia_Lance_Jogador} width={50} height={50} />
                                                                                                    </Grid>
                                                                                                </Grid>
                                                                                                <Grid container size={{ xs: 12, sm: 6, md: 6 }} display="flex" justifyContent={"center"} textAlign="center" direction="column">
                                                                                                    <Grid size={{ xs: 12, sm: 12 }}>
                                                                                                        {r.franquia_Direitos_Jogador !== null ? (
                                                                                                            <><Typography variant="body1" style={{ fontSize: 14 }} >
                                                                                                                Franquia Direitos
                                                                                                            </Typography>
                                                                                                                <Typography variant="body2" style={{ fontSize: 13 }}>
                                                                                                                    <span style={{ color: r.codigo_Franquia_Direitos_Jogador === codigoFranquia ? "#117ED9" : "white" }}> {r.franquia_Direitos_Jogador}</span>
                                                                                                                </Typography>
                                                                                                                <img src={r.logo_Franquia_Direitos_Jogador === null ? showImagemFranquia : r.logo_Franquia_Direitos_Jogador} alt={r.franquia_Direitos_Jogador} width={50} height={50} />
                                                                                                            </>
                                                                                                        ) : <Typography variant="body1" >
                                                                                                            Livre
                                                                                                        </Typography>}
                                                                                                    </Grid>
                                                                                                </Grid>
                                                                                            </Box>
                                                                                        </Grid>
                                                                                    </Grid>
                                                                                </Grid>
                                                                            </CardContent>
                                                                        </Card>
                                                                    )
                                                                    :
                                                                    (
                                                                        <Card key={`Card${i}`} sx={{ border: "2px solid", borderColor: "#303134", m: UtilidadeService.isMobile() ? 0 : 1, width: "100%" }}>
                                                                            <CardContent sx={{ padding: 1, paddingBottom: 1, backgroundColor: "#252525", color: "white" }} >
                                                                                <Grid container size={{ xs: 12, sm: 12, md: 12 }}>
                                                                                    <Grid size={{ xs: 12, sm: 6, md: 3 }} display="flex" flexDirection="column">
                                                                                        <Box width="100%" display="flex" flexDirection="column">
                                                                                            {/* <Typography key={`ty${i}1`} variant="h6" > */}
                                                                                            <img src={r.foto_Jogador} alt={r.nome_Jogador} width={UtilidadeService.isMobile() ? 40 : 50} height={UtilidadeService.isMobile() ? 40 : 50} />
                                                                                            {/* </Typography> */}
                                                                                            <Typography key={`ty${i}2`} variant="body1">
                                                                                                Nome Jogador: {r.nome_Jogador} <span style={{ color: "#ED59BC" }}>{r.restrito_Jogador === true ? "®" : r.draftado === true ? <span style={{ color: "#6abdcb" }}>Ð</span> : ""}</span>
                                                                                            </Typography>
                                                                                            <Typography key={`ty${i}3`} variant="body1" >
                                                                                                Último Contrato: R${r.valor_Ultimo_Contrato_Jogador !== "0" ? moedaRealLocaleValue(r.valor_Ultimo_Contrato_Jogador) : r.valor_Ultimo_Contrato_Jogador}
                                                                                            </Typography>
                                                                                            <Typography key={`ty${i}4`} variant="body1" style={{ display: "flex", justifyContent: "flex-start" }}>
                                                                                                Posição: <span style={{ paddingLeft: "4px" }}>{carregaPosicao(r.posicao_Jogador_1, r.posicao_Jogador_2, r.posicao_Jogador_3)}</span>
                                                                                            </Typography>
                                                                                        </Box>
                                                                                    </Grid>
                                                                                    <Grid container size={{ xs: 12, sm: 6, md: 2 }} display="flex"  >
                                                                                        <Grid container size={{ xs: 12, sm: 12, md: 12 }} display="flex" >
                                                                                            <Box width="100%" display="flex" flexDirection="row" justifyItems="center" alignItems="center">
                                                                                                <Grid container size={{ xs: 12, sm: 6, md: 6 }} display="flex" justifyContent="center" textAlign="center" direction="row">
                                                                                                    <Grid size={{ xs: 12, sm: 12 }}>
                                                                                                        <Typography variant="body1" style={{ fontWeight: "bold" }}>
                                                                                                            Valor Lance
                                                                                                        </Typography>
                                                                                                        <Typography variant="body2" style={{ fontWeight: "bold" }} >
                                                                                                            R${moedaRealLocaleValue(r.valor)}
                                                                                                        </Typography>
                                                                                                    </Grid>
                                                                                                    <Grid size={{ xs: 12, sm: 12 }} padding={1}>
                                                                                                        <Typography variant="body1" >
                                                                                                            Contrato
                                                                                                        </Typography>
                                                                                                        <Typography variant="body2" >
                                                                                                            {r.tempo_Contrato} Anos
                                                                                                        </Typography>
                                                                                                    </Grid>
                                                                                                </Grid>
                                                                                            </Box>
                                                                                        </Grid>
                                                                                    </Grid>
                                                                                    <Grid container size={{ xs: 12, sm: 6, md: 3 }} display="flex"  >
                                                                                        <Grid container size={{ xs: 12, sm: 12, md: 12 }} display="flex" >
                                                                                            <Box width="100%" display="flex" flexDirection="row" justifyItems="center" alignItems="center">
                                                                                                <Grid container size={{ xs: 12, sm: 6, md: 6 }} display="flex" justifyContent="center" textAlign="center" direction="column">
                                                                                                    <Grid size={{ xs: 12, sm: 12 }}>
                                                                                                        <Typography variant="body1" >
                                                                                                            Franquia Lance
                                                                                                        </Typography>
                                                                                                        <Typography variant="body2" >
                                                                                                            <span style={{ color: r.codigo_Franquia === codigoFranquia ? "#66bb6a" : "white" }}> {r.franquia_Lance_Jogador}</span>
                                                                                                        </Typography>
                                                                                                        <img src={r.logo_Franquia_Lance_Jogador === null ? showImagemFranquia : r.logo_Franquia_Lance_Jogador} alt={r.franquia_Lance_Jogador} width={50} height={50} />
                                                                                                    </Grid>
                                                                                                </Grid>
                                                                                                <Grid container size={{ xs: 12, sm: 6, md: 6 }} display="flex" justifyContent={"center"} textAlign="center" direction="column">
                                                                                                    <Grid size={{ xs: 12, sm: 12 }}>
                                                                                                        {r.franquia_Direitos_Jogador !== null ? (
                                                                                                            <><Typography variant="body1" >
                                                                                                                Franquia Direitos
                                                                                                            </Typography>
                                                                                                                <Typography variant="body2" >
                                                                                                                    <span style={{ color: r.codigo_Franquia_Direitos_Jogador === codigoFranquia ? "#117ED9" : "white" }}> {r.franquia_Direitos_Jogador}</span>
                                                                                                                </Typography>
                                                                                                                <img src={r.logo_Franquia_Direitos_Jogador === null ? showImagemFranquia : r.logo_Franquia_Direitos_Jogador} alt={r.franquia_Direitos_Jogador} width={50} height={50} />
                                                                                                            </>
                                                                                                        ) : <Typography variant="body1" >
                                                                                                            Livre
                                                                                                        </Typography>}
                                                                                                    </Grid>
                                                                                                </Grid>
                                                                                            </Box>
                                                                                        </Grid>
                                                                                    </Grid>
                                                                                    <Grid container size={{ xs: 12, sm: 4, md: 2 }} display="flex" justifyContent="center" textAlign="center" direction="column">
                                                                                        <Grid size={{ xs: 12, sm: 12 }}>
                                                                                            <Typography variant="body2" sx={{ color: handleCalculartempo(r.data_Fim_Lance) <= 1 ? "red" : handleCalculartempo(r.data_Fim_Lance) === 2 ? "orange" : "white", }}>
                                                                                                Duração (Hrs):
                                                                                            </Typography>
                                                                                            {i <= 3 ? 
                                                                                            UseCountdown(r.data_Fim_Lance, i, handleCalculartempo(r.data_Fim_Lance) <= 1 ? "red" : handleCalculartempo(r.data_Fim_Lance) === 2 ? "orange" : "white") 
                                                                                            : UseDiff(r.data_Fim_Lance, i, handleCalculartempo(r.data_Fim_Lance) <= 1 ? "red" : handleCalculartempo(r.data_Fim_Lance) === 2 ? "orange" : "white")}
                                                                                            <Typography variant="body1" >
                                                                                                Tempo Final
                                                                                            </Typography>
                                                                                            <Typography variant="body2" >
                                                                                                {new Date(r.data_Fim_Lance).toLocaleDateString("pt-Br")} {new Date(r.data_Fim_Lance).toLocaleTimeString("pt-Br")}
                                                                                            </Typography>
                                                                                        </Grid>
                                                                                    </Grid>
                                                                                    <Grid container size={{ xs: 12, sm: 6, md: 2 }} display="flex" justifyContent="center" alignItems="center" >
                                                                                        <Grid container size={{ xs: 12, sm: 6, md: 6 }} display={(user.codUsuario === r.codUsuCriacao || moment.tz(r.data_Fim_Lance,'America/Sao_Paulo') <= moment().tz('America/Sao_Paulo').locale('pt-BR') || r.aprovacao_Restrito) ? "none" : "flex"} direction="column" flex={2}>
                                                                                            <Grid size={{ xs: 12, sm: 12 }}>
                                                                                                <Button
                                                                                                    color="success"
                                                                                                    variant="outlined"
                                                                                                    disableElevation
                                                                                                    onClick={() => handleAcaoLeilao(listaLanceFreeAgency[0], Number(dadosLiga?.codigo_Franquia), dadosLiga?.tipo_Free_Agency, dadosLiga?.codigo_Tipo_Posicao_Confronto, Number(dadosLiga?.porcentagem_Contrato_Ajustavel))}
                                                                                                    startIcon={<Icon>check</Icon>}
                                                                                                    disabled={isLoading}
                                                                                                >
                                                                                                    <Typography variant="button" whiteSpace="nowrap" textOverflow="ellipsis" overflow="hidden">
                                                                                                        Aumentar
                                                                                                    </Typography>
                                                                                                </Button>
                                                                                            </Grid>
                                                                                        </Grid>
                                                                                    </Grid>
                                                                                </Grid>
                                                                            </CardContent>
                                                                        </Card>
                                                                    )
                                                            ))}
                                                    </Grid>
                                                </Grid>
                                            )}

                                            <Grid container size={{ xs: 12, sm: 12 }} >
                                                {listaLanceFreeAgencyRestrito.length > 0 && (
                                                    <Grid container size={{ xs: 12, sm: 12 }} display="flex" justifyContent="center" direction="row" >
                                                        <Grid size={{ xs: 12, sm: 12 }} >
                                                            <Typography variant="h6">Free Agency Restrito</Typography>
                                                            <hr />
                                                            {!removeLoading && <Loading />}
                                                        </Grid>
                                                        <Grid size={{ xs: 12, sm: 12 }} paddingTop={2} height="auto" width={"100%"}  >
                                                            <Box sx={{
                                                                height: 'auto', width: '100%', backgroundColor: themeName === "light" ? "#cfcfcd" : "auto",
                                                                '& .super-app-theme--header': {
                                                                    backgroundColor: theme.palette.common.black,
                                                                    color: theme.palette.common.white
                                                                },
                                                                '& .super-app.negative': {
                                                                    color: 'red',
                                                                    fontWeight: 'bold'
                                                                },
                                                                '& .super-app.positive': {
                                                                    color: themeName === "light" ? "black" : "auto",
                                                                }
                                                            }}>
                                                                <DataGrid
                                                                    localeText={ptBR.components.MuiDataGrid.defaultProps.localeText}
                                                                    autoHeight
                                                                    getRowId={(rows) => rows.codigo}
                                                                    rows={listaLanceFreeAgencyRestrito}
                                                                    columns={freeAgencyRestritoColumns}
                                                                    initialState={{
                                                                        pagination: {
                                                                            paginationModel: {
                                                                                pageSize: 12,
                                                                                //page: paginaRestrito,
                                                                            },
                                                                        },
                                                                    }}

                                                                    pageSizeOptions={[12, 24, 50, 100]}
                                                                    disableRowSelectionOnClick
                                                                    disableVirtualization
                                                                    sx={{
                                                                        fontSize: UtilidadeService.isMobile() ? 11 : "auto",
                                                                    }}
                                                                />
                                                            </Box>
                                                        </Grid>
                                                    </Grid>
                                                )}
                                            </Grid>

                                            {showGridFreeAgency && (
                                                <Grid size={{ xs: 12, sm: 12 }} container spacing={1} paddingBottom={3}>
                                                    <Grid container size={{ xs: 12, sm: 12 }}  >
                                                        <Grid size={{ xs: 12, sm: 12 }} display="flex" textAlign="initial" >
                                                            <Typography variant="h6" style={{ fontSize: UtilidadeService.isMobile() ? 16 : 20 }}>Free Agency</Typography>
                                                            <hr />
                                                        </Grid>
                                                    </Grid>
                                                    <Grid container size={{ xs: 12, sm: 12 }} display="flex" spacing={1}  >
                                                        <Grid size={{ xs: 12, sm: 6, md: 3 }} >
                                                            <Autocomplete
                                                                openText="Abrir"
                                                                closeText="Fechar"
                                                                noOptionsText="Sem opções"
                                                                loadingText="Carregando..."
                                                                disablePortal
                                                                options={opcoesAutoCompleteJogador}
                                                                loading={isLoading}
                                                                disabled={isLoading}
                                                                value={autoCompleteSelectedOption}
                                                                size={UtilidadeService.isMobile() ? "small" : "medium"}
                                                                onChange={(event, newValue) => { setSelectedIdComplete(newValue?.codigo); }}
                                                                popupIcon={isLoading ? <CircularProgress size={UtilidadeService.isMobile() ? 20 : 28} /> : undefined}
                                                                renderInput={(params) => (
                                                                    <TextField
                                                                        {...params}
                                                                        label="Jogador"
                                                                        slotProps={{
                                                                            htmlInput: {
                                                                                ...params.InputProps,
                                                                                style: { fontSize: UtilidadeService.isMobile() ? 14 : 16 }
                                                                            },
                                                                            inputLabel: {
                                                                                style: {
                                                                                    fontSize: UtilidadeService.isMobile() ? 13 : 16
                                                                                }
                                                                            }
                                                                        }}
                                                                    />
                                                                )}
                                                            />
                                                        </Grid>
                                                        <Grid size={{ xs: 12, sm: 6, md: 3 }} >
                                                            <VTextMaskCustom
                                                                fullWidth
                                                                name="selecaoJogador"
                                                                disabled={isLoading}
                                                                label="Valor"
                                                                type="text"
                                                                typeMask="currency"
                                                                value={valorSalarioJogador}
                                                                onChange={e => setValorSalarioJogador(e.target.value)}
                                                                slotProps={{
                                                                    inputLabel: {
                                                                        shrink: edicao ? true : undefined,
                                                                    }
                                                                }}
                                                            />
                                                        </Grid>
                                                        <Grid size={{ xs: 12, sm: 6, md: 2 }} >
                                                            <FormControl fullWidth>
                                                                <InputLabel id="demo-simple-select-label">Anos</InputLabel>
                                                                <Select
                                                                    labelId="demo-simple-select-label"
                                                                    id="demo-simple-select"
                                                                    label="Anos"
                                                                    value={anoSelecionado}
                                                                    onChange={(e) => setAnoSelecionado(Number(e.target.value))}
                                                                    defaultValue={0}
                                                                    style={{ fontSize: UtilidadeService.isMobile() ? 12 : 14, height: UtilidadeService.isMobile() ? 35 : "auto" }}
                                                                >
                                                                    <MenuItem key="0" value={0}>Selecione...</MenuItem>
                                                                    {
                                                                        AnosTemporadas.map(qtd =>
                                                                            <MenuItem key={qtd.codigo} value={qtd.codigo}>{qtd.label}</MenuItem>
                                                                        )
                                                                    }
                                                                </Select>
                                                            </FormControl>
                                                        </Grid>
                                                        <Grid size={{ xs: 6, sm: 6, md: 2 }} display="flex" alignItems="center" justifyContent="flex-end" justifyItems="center" textAlign="end">
                                                            <Button
                                                                color="error"
                                                                variant="outlined"
                                                                disableElevation
                                                                onClick={() => setShowGridFreeAgency(false)}
                                                                startIcon={<Icon>cancel</Icon>}
                                                                disabled={isLoading}
                                                            >
                                                                <Typography variant="button" whiteSpace="nowrap" textOverflow="ellipsis" overflow="hidden">
                                                                    Cancelar
                                                                </Typography>
                                                            </Button>
                                                        </Grid>
                                                        <Grid size={{ xs: 6, sm: 6, md: 2 }} display="flex" alignItems="center" justifyContent="flex-end" justifyItems="center" textAlign="end">
                                                            <Button
                                                                color="primary"
                                                                variant="contained"
                                                                disableElevation
                                                                onClick={handleSave}
                                                                endIcon={<Icon>add</Icon>}
                                                                disabled={desativar}
                                                            >
                                                                Salvar
                                                            </Button>
                                                        </Grid>
                                                    </Grid>
                                                </Grid>
                                            )}
                                        </Grid>
                                    )
                                        : <Grid size={{ xs: 12, sm: 12 }} textAlign="initial" >
                                            <Typography variant="h6">Free Agency fechado!</Typography>
                                            <hr />
                                        </Grid>
                                    }
                                </TabPanel>
                                <TabPanel value={value} index={1}>
                                    {(!removeLoading || isLoading) && <Loading />}
                                    <Grid container size={{ xs: 12, sm: 12 }} >
                                        <Grid size={{ xs: 12, sm: 2, md: 2 }} padding={1}>
                                            <Autocomplete
                                                openText="Abrir"
                                                closeText="Fechar"
                                                noOptionsText="Sem opções"
                                                loadingText="Carregando..."
                                                disablePortal
                                                options={opcoesAutoCompleteJogadorFiltro}
                                                loading={isLoading}
                                                disabled={isLoading}
                                                value={autoCompleteSelectedOptionFiltro}
                                                size={UtilidadeService.isMobile() ? "small" : "medium"}
                                                onChange={(event, newValue) => { setSelectedIdCompleteFiltro(newValue?.codigo); }}
                                                popupIcon={isLoading ? <CircularProgress size={UtilidadeService.isMobile() ? 20 : 28} /> : undefined}
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        label="Jogador"
                                                        slotProps={{
                                                            // htmlInput: {
                                                            //     ...params.InputProps,
                                                            //     style: { fontSize: UtilidadeService.isMobile() ? 14 : 16 }
                                                            // },
                                                            inputLabel: {
                                                                style: {
                                                                    fontSize: UtilidadeService.isMobile() ? 13 : 16
                                                                }
                                                            }
                                                        }}
                                                    />
                                                )}
                                            />
                                        </Grid>
                                        <Grid size={{ xs: 12, sm: 2, md: 2 }} padding={1}>
                                            <FormControl fullWidth>
                                                <InputLabel id="demo-simple-select-label">Posição</InputLabel>
                                                <Select
                                                    label="Posição"
                                                    value={posicaoFiltro}
                                                    onChange={(e) => { setPosicaoFiltro(Number(e.target.value)); }}
                                                    style={{ fontSize: UtilidadeService.isMobile() ? 12 : 13, height: UtilidadeService.isMobile() ? 35 : "auto" }}
                                                >
                                                    <MenuItem key="0" value={0}>Selecione...</MenuItem>
                                                    {
                                                        lstPosicoes.map(qtd =>
                                                            <MenuItem key={qtd.codigo} value={qtd.codigo}>{qtd.label}</MenuItem>
                                                        )
                                                    }
                                                </Select>
                                            </FormControl>
                                        </Grid>
                                        <Grid size={{ xs: 12, sm: 2, md: 2 }} padding={1}>
                                            <FormControl fullWidth>
                                                <InputLabel id="demo-simple-select-label">Direito</InputLabel>
                                                <Select
                                                    label="Direito"
                                                    value={codigofranquiaDireitoFiltro}
                                                    onChange={(e) => { setCodigofranquiaDireitoFiltro(Number(e.target.value)); }}
                                                    style={{ fontSize: UtilidadeService.isMobile() ? 12 : 13, height: UtilidadeService.isMobile() ? 35 : "auto" }}
                                                >
                                                    <MenuItem key="0" value={0}>Selecione...</MenuItem>
                                                    {
                                                        lstFranquias.map(qtd =>
                                                            <MenuItem key={qtd.codigo} value={qtd.codigo}>{qtd.label}</MenuItem>
                                                        )
                                                    }
                                                </Select>
                                            </FormControl>
                                        </Grid>
                                        <Grid size={{ xs: 12, sm: 2, md: 2 }} padding={1}>
                                            <FormControl fullWidth>
                                                <InputLabel id="demo-simple-select-label">Lance</InputLabel>
                                                <Select
                                                    labelId="demo-simple-select-label"
                                                    id="demo-simple-select"
                                                    label="Lance"
                                                    value={codigofranquiaLanceFiltro}
                                                    onChange={(e) => { setCodigofranquiaLanceFiltro(Number(e.target.value)); }}
                                                    style={{ fontSize: UtilidadeService.isMobile() ? 12 : 13, height: UtilidadeService.isMobile() ? 35 : "auto" }}
                                                >
                                                    <MenuItem key="0" value={0}>Selecione...</MenuItem>
                                                    {
                                                        lstFranquias.map(qtd =>
                                                            <MenuItem key={qtd.codigo} value={qtd.codigo}>{qtd.label}</MenuItem>
                                                        )
                                                    }
                                                </Select>
                                            </FormControl>
                                        </Grid>
                                        <Grid size={{ xs: 6, sm: 2, md: 2 }} display={"flex"} justifyContent="center" justifyItems="center" padding={1}>
                                            <Button
                                                color="error"
                                                variant="contained"
                                                disableElevation
                                                style={{ height: UtilidadeService.isMobile() ? "32px" : "38px", alignSelf: "center", display: showBotaoCancelar ? "flex" : "none" }}
                                                onClick={() => handleLimparFiltros()}
                                                endIcon={<Icon style={{ fontSize: UtilidadeService.isMobile() ? 14 : 16 }}>clear</Icon>}>
                                                <span style={{ fontSize: UtilidadeService.isMobile() ? 14 : 16 }} >Limpar</span>
                                            </Button>
                                        </Grid>
                                        <Grid size={{ xs: 6, sm: 2, md: 2 }} display={"flex"} justifyContent="center" justifyItems="center" padding={1}>
                                            <Button
                                                color="primary"
                                                variant="contained"
                                                disableElevation
                                                style={{ height: UtilidadeService.isMobile() ? "32px" : "38px", alignSelf: "center" }}
                                                onClick={() => { setShowBotaoCancelar(true); CarregarListaJogadores(false) }}
                                                endIcon={<Icon style={{ fontSize: UtilidadeService.isMobile() ? 14 : 16 }}>search</Icon>}>
                                                <span style={{ fontSize: UtilidadeService.isMobile() ? 14 : 16 }} >Pesquisar</span>
                                            </Button>
                                        </Grid>
                                    </Grid>
                                    <Grid container size={{ xs: 12, sm: 12 }} >
                                        <Box sx={{
                                            height: 'auto', width: '100%', backgroundColor: themeName === "light" ? "#cfcfcd" : "auto",
                                            '& .super-app-theme--header': {
                                                backgroundColor: theme.palette.common.black,
                                                color: theme.palette.common.white
                                            },
                                            '& .super-app.negative': {
                                                color: 'red',
                                                fontWeight: 'bold'
                                            },
                                            '& .super-app.positive': {
                                               color: themeName === "light" ? "black" : "auto",
                                            },
                                        }}>
                                            <DataGrid
                                                localeText={ptBR.components.MuiDataGrid.defaultProps.localeText}
                                                autoHeight
                                                getRowId={(rows) => rows.codigo}
                                                rows={rows}
                                                columns={columns}
                                                initialState={{
                                                    pagination: {
                                                        paginationModel: {
                                                            pageSize: 10,
                                                            //page: pagina,
                                                        },
                                                    },
                                                }}
                                                columnVisibilityModel={{ codigo: false, foto: UtilidadeService.isMobile() ? false : true }}
                                                pageSizeOptions={[10, 24, 50, 100]}
                                                disableRowSelectionOnClick
                                                disableVirtualization
                                                disableColumnFilter
                                                disableColumnMenu={UtilidadeService.isMobile() ? true : false}
                                                sx={{
                                                    fontSize: UtilidadeService.isMobile() ? 11 : "auto",
                                                }}
                                            />
                                        </Box>
                                    </Grid>
                                </TabPanel>
                                <TabPanel value={value} index={2}>
                                    {(!removeLoading || isLoading) && <Loading />}
                                    <Grid container size={{ xs: 12, sm: 12 }} height="auto" width={"100%"} >
                                        <Box sx={{
                                            height: 'auto', width: '100%', backgroundColor: themeName === "light" ? "#cfcfcd" : "auto",
                                            '& .super-app-theme--header': {
                                                backgroundColor: theme.palette.common.black,
                                                color: theme.palette.common.white,
                                            },
                                            '& .super-app.negative': {
                                                color: 'red',
                                                fontWeight: 'bold'
                                            },
                                            '& .super-app.positive': {
                                                color: themeName === "light" ? "black" : "auto",
                                            },
                                        }}>
                                            <DataGrid
                                                localeText={ptBR.components.MuiDataGrid.defaultProps.localeText}

                                                getRowId={(rowsTimes) => rowsTimes.codigo}
                                                rows={rowsTimes}
                                                columns={columnsTimes}
                                                initialState={{
                                                    pagination: {
                                                        paginationModel: {
                                                            pageSize: 25,
                                                            //page: pagina,
                                                        },
                                                    },
                                                }}
                                                columnVisibilityModel={{ codigo: false, }}
                                                pageSizeOptions={[25]}
                                                autoHeight
                                                disableRowSelectionOnClick
                                                disableVirtualization
                                                disableColumnFilter
                                                disableColumnMenu={UtilidadeService.isMobile() ? true : false}
                                                sx={{
                                                    fontSize: UtilidadeService.isMobile() ? 11 : "auto",
                                                }}
                                            />
                                        </Box>
                                    </Grid>
                                </TabPanel>
                                <TabPanel value={value} index={3}>
                                    {(!removeLoading || isLoading) && <Loading />}
                                    <Grid container size={{ xs: 12, sm: 12 }} height="auto" width={"100%"} >
                                        <Box sx={{
                                            height: 'auto', width: '100%', backgroundColor: themeName === "light" ? "#cfcfcd" : "auto",
                                            '& .super-app-theme--header': {
                                                backgroundColor: theme.palette.common.black,
                                                color: theme.palette.common.white,
                                            },
                                            '& .super-app.negative': {
                                                color: 'red',
                                                fontWeight: 'bold'
                                            },
                                            '& .super-app.positive': {
                                                color: themeName === "light" ? "black" : "auto",
                                            },
                                        }}>
                                            <DataGrid
                                                localeText={ptBR.components.MuiDataGrid.defaultProps.localeText}
                                                autoHeight
                                                getRowId={(rowsSalarios) => rowsSalarios.codigo}
                                                rows={rowsSalarios}
                                                columns={columnsSalarios}
                                                initialState={{
                                                    pagination: {
                                                        paginationModel: {
                                                            pageSize: 20,
                                                            //page: pagina,
                                                        },
                                                    },
                                                }}
                                                columnVisibilityModel={{ codigo: false, }}
                                                pageSizeOptions={[20]}
                                                disableRowSelectionOnClick
                                                disableVirtualization
                                                disableColumnFilter={UtilidadeService.isMobile() ? true : false}
                                                disableColumnMenu={UtilidadeService.isMobile() ? true : false}
                                                sx={{
                                                    fontSize: UtilidadeService.isMobile() ? 11 : "auto",
                                                }}

                                            />
                                        </Box>
                                    </Grid>
                                </TabPanel>
                            </Paper>
                        </Grid>
                    </Grid >
                </Box >
            </VForm >
            {showModalMensagem && <DialogMensagem dados={dadosModalMensagem} isModalVisible={showModalMensagem} onBackClickClose={toggleModalMensagem} />}
            {showModalEvent && <DialogEvent dados={dadosModalEvent} isModalVisible={showModalEvent} onBackClickClose={toggleModalEvent} />}
        </LayoutBaseDePagina >
    );
};


